import { iterate, toArray, map as map_1, empty as empty_1, singleton, append, delay, toList } from "../../client/src/fable_modules/fable-library.3.7.17/Seq.js";
import { createElement } from "react";
import * as react from "react";
import { NumberFieldFloat, DiscountOption__get_Label, FileField, TextFieldDisabled, TextField, OptionField, DiscountOption, CheckBox, CheckIcon, DisplayData, Info, InfoTitle } from "../DesignSystem.fs.js";
import { Col, Row } from "../../Components/UtilComponents.fs.js";
import { alignEnd, Padding, modal, MarginLeft, Boldness, MarginTop, MarginRight, error, PaddingLeft, PaddingTop, MarginBottom, flexExpand, Gap } from "../../Styles/Utils.fs.js";
import { length, item, map as map_2, toArray as toArray_1, tryFind, ofArray, empty, singleton as singleton_1 } from "../../client/src/fable_modules/fable-library.3.7.17/List.js";
import { MuiHelpers_createElement } from "../../client/src/fable_modules/Feliz.MaterialUI.1.2.6/./Mui.fs.js";
import Paper from "@material-ui/core/Paper";
import { Feliz_prop__prop_fss_Static_72C268A9 } from "../../client/src/fable_modules/Fss-lib.Feliz.1.0.3/FssFeliz.fs.js";
import { FlexClasses_FlexShrinkGrow__value_5E38073B } from "../../client/src/fable_modules/Fss-lib.Core.1.0.4/Types/Flex.fs.js";
import { FlexGrow } from "../../client/src/fable_modules/Fss-lib.Core.1.0.4/css/Flex.fs.js";
import Divider from "@material-ui/core/Divider";
import { CustomerCompanyData, CustomerData2, CustomerPersonData, DossierCustomerSelection, DossierCustomer, CreateDossierDataContact, InvoicePricing, CreateDossierData2, Customer2__get_Code, Customer2__get_CustomerOrCompanyName, AssignmentDocument, PhoneNumber_get_Create, CommentSource as CommentSource_1, CreateDossierData, TypeOfDiscount, DossierStatus, PartnerId as PartnerId_1, DossierOwner__get_Address, InspectionLocationExtra, WoonhuisBuildingForm_get_list, WoonhuisBuildingForm__get_label, InspectionLocation as InspectionLocation_1, CommentType, TypeOfDossierData___UnsafeCreate_Z1D754B91, NonEmptyString, DossierOwner as DossierOwner_4, Compensation as Compensation_3, Decimal___UnsafeCreate_32C73145, OwnerStatus as OwnerStatus_2, NonEmptyString___UnsafeCreate_Z721C83C5, Decimal_get_Create, Compensation_get_DefaultCompensation, ContactOwner, DossierClient, AsbestInventoryData_Create_7B10C0C6, TypeOfDossierData_Create_Z6219B46, TypeOfDossier as TypeOfDossier_1, AsbestInventory, DossierKind, EmptyString_get_Create, NonEmptyString_get_Create, SelectOptionData$1_Create_Z510A3DC0, InvoicePricingModule_string, HomeVisitContactModule_string, CustomerData2__get_Address, CustomerData2__get_PhoneNumber, CustomerData2__get_Email, Customer2__get_Address, Customer2__get_PhoneNumber, PhoneNumber___UnsafeUnwrap_23E45174, Customer2__get_Email, Email___UnsafeUnwrap_Z27D11339, NonEmptyString___UnsafeUnwrap_Z73AD07C } from "../../shared/Domain.fs.js";
import { toArray as toArray_2, some, bind, map, defaultArg } from "../../client/src/fable_modules/fable-library.3.7.17/Option.js";
import { InspectionLocation_extra, Compensation_compensation, InspectionLocation_type$0027, Address_address } from "../../shared/Format.fs.js";
import { Interop_reactApi } from "../../client/src/fable_modules/Feliz.1.68.0/./Interop.fs.js";
import List from "@material-ui/core/List";
import { useForm, useFormValidator, useFormField } from "../../CustomHooks/ComposedForm.fs.js";
import { createObj, compare, equals } from "../../client/src/fable_modules/fable-library.3.7.17/Util.js";
import { ofSeq } from "../../client/src/fable_modules/fable-library.3.7.17/Set.js";
import { Compensation_fromDomain, AsbestInventoryProfile_get_defaultInventory, AsbestInventoryProfile } from "../../shared/DomainHelpers.fs.js";
import { useUsername, useToggle } from "../../CustomHooks/CustomHooks.fs.js";
import { ParseNonNegative } from "../../shared/Validators.fs.js";
import { CreateAddressFormWithReset, useAddressForm } from "../AddressHook.fs.js";
import { useReact_useElementRef, useReact_useButtonRef, useReact_useEffect_Z101E1A95, useFeliz_React__React_useState_Static_1505 } from "../../client/src/fable_modules/Feliz.1.68.0/React.fs.js";
import { ChooseCertificateContact, ChooseInvoicing, ChooseContact, FindCustomer, CustomerOption, Invoiced, useCreateCustomerCompanyForm, useCreateCustomerPersonForm, CustomerOption_get_none, ChooseOwner, useCreateDossierOwnerPersonForm, useCreateDossierOwnerCompanyForm } from "../Contacts.fs.js";
import { getPartnerType, filterPartnerOptions, PartnerOption, PartnerOption_get_empty, PartnerOption_get_none } from "../partner/PartnerUtils.fs.js";
import { join, printf, toConsole, isNullOrEmpty, isNullOrWhiteSpace } from "../../client/src/fable_modules/fable-library.3.7.17/String.js";
import { fromParts, compare as compare_1 } from "../../client/src/fable_modules/fable-library.3.7.17/Decimal.js";
import RadioGroup from "@material-ui/core/RadioGroup";
import { ChooseInspectionLocationFormCheckbox, InspectionLocationType } from "../InspectionLocation.fs.js";
import { Step, stepString, steps, CompensationOptions, CompensationOptionsRestricted, DossierCreatePageSource } from "../DossierUtils.fs.js";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Switch from "@material-ui/core/Switch";
import { Browser_Types_Event__Event_get_Value, Browser_Types_Event__Event_get_Checked } from "../../client/src/fable_modules/Feliz.MaterialUI.1.2.6/../Fable.React.7.4.0/Fable.React.Extensions.fs.js";
import TextField_1 from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Chip from "@material-ui/core/Chip";
import Grid from "@material-ui/core/Grid";
import { SafeNotNullCheck } from "../Utils.fs.js";
import { CommentEditor, CommentTypeTabs } from "../CommentEditor.fs.js";
import Button from "@material-ui/core/Button";
import { RouterModule_nav } from "../../client/src/fable_modules/Feliz.Router.3.10.0/./Router.fs.js";
import { CommentData } from "../../shared/Api.fs.js";
import { useSnackbar } from "notistack";
import { mapIndexed } from "../../client/src/fable_modules/fable-library.3.7.17/Array.js";
import Stepper from "@material-ui/core/Stepper";
import Step_1 from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Modal from "@material-ui/core/Modal";
import { CreateCustomerForm } from "../CustomerForms.fs.js";
import { DisplayDeferred } from "../DisplayDeferred.fs.js";
import { EnqueueSnackbarOption, SnackbarProp_Variant_Z609E1E86, ProviderContext__enqueueSnackbar_Z1776A768 } from "../../Notistack/Notistack.fs.js";

export function Review(reviewInputProps) {
    const isPartnerSelected = reviewInputProps.isPartnerSelected;
    const partnerName = reviewInputProps.partnerName;
    const dossierDataContact = reviewInputProps.dossierDataContact;
    const dossierData = reviewInputProps.dossierData;
    const children = toList(delay(() => append(singleton(createElement(InfoTitle, {
        text: "Factuur",
    })), delay(() => append(singleton(createElement(Info, {
        secondary: "Verantwoordelijkheid",
        primary: "Klant wordt direct gefactureerd",
    })), delay(() => singleton(createElement(Row, {
        classes: singleton_1(Gap.L),
        children: toList(delay(() => {
            let elems;
            return append(singleton(MuiHelpers_createElement(Paper, [Feliz_prop__prop_fss_Static_72C268A9(singleton_1(FlexClasses_FlexShrinkGrow__value_5E38073B(FlexGrow, 2))), (elems = [createElement(Col, {
                classes: empty(),
                children: ofArray([createElement(InfoTitle, {
                    text: "Klant",
                }), MuiHelpers_createElement(Divider, []), createElement(DisplayData, {
                    data: toList(delay(() => {
                        let matchValue_4, person_2, company_2, matchValue_3, person_1, company_1, matchValue_1, person, company;
                        const matchValue = dossierDataContact.InvoicingParty;
                        switch (matchValue.tag) {
                            case 1: {
                                const matchValue_2 = matchValue.fields[0];
                                if (matchValue_2.tag === 0) {
                                    const customer_3 = matchValue_2.fields[0];
                                    return append((matchValue_4 = customer_3, (matchValue_4.tag === 0) ? ((person_2 = matchValue_4.fields[0], append(singleton(["Voornaam", NonEmptyString___UnsafeUnwrap_Z73AD07C(person_2.FirstName)]), delay(() => singleton(["Naam", NonEmptyString___UnsafeUnwrap_Z73AD07C(person_2.LastName)]))))) : ((company_2 = matchValue_4.fields[0], append(singleton(["Bedrijfsnaam", NonEmptyString___UnsafeUnwrap_Z73AD07C(company_2.CompanyName)]), delay(() => singleton(["Bedrijfstype", defaultArg(map(NonEmptyString___UnsafeUnwrap_Z73AD07C, company_2.CompanyType), "-")])))))), delay(() => append(singleton(["Emailadres", Email___UnsafeUnwrap_Z27D11339(Customer2__get_Email(customer_3))]), delay(() => append(singleton(["Telefoon", defaultArg(map(PhoneNumber___UnsafeUnwrap_23E45174, Customer2__get_PhoneNumber(customer_3)), "-")]), delay(() => singleton(["Adres", Address_address(Customer2__get_Address(customer_3))])))))));
                                }
                                else {
                                    const customer_2 = matchValue_2.fields[0];
                                    return append((matchValue_3 = customer_2, (matchValue_3.tag === 0) ? ((person_1 = matchValue_3.fields[0], append(singleton(["Voornaam", NonEmptyString___UnsafeUnwrap_Z73AD07C(person_1.FirstName)]), delay(() => singleton(["Naam", NonEmptyString___UnsafeUnwrap_Z73AD07C(person_1.LastName)]))))) : ((company_1 = matchValue_3.fields[0], append(singleton(["Bedrijfsnaam", NonEmptyString___UnsafeUnwrap_Z73AD07C(company_1.CompanyName)]), delay(() => singleton(["Bedrijfstype", defaultArg(map(NonEmptyString___UnsafeUnwrap_Z73AD07C, company_1.CompanyType), "-")])))))), delay(() => append(singleton(["Emailadres", Email___UnsafeUnwrap_Z27D11339(CustomerData2__get_Email(customer_2))]), delay(() => append(singleton(["Telefoon", defaultArg(map(PhoneNumber___UnsafeUnwrap_23E45174, CustomerData2__get_PhoneNumber(customer_2)), "-")]), delay(() => singleton(["Adres", Address_address(CustomerData2__get_Address(customer_2))])))))));
                                }
                            }
                            case 2: {
                                return empty_1();
                            }
                            default: {
                                const customer = matchValue.fields[0];
                                return append((matchValue_1 = customer, (matchValue_1.tag === 0) ? ((person = matchValue_1.fields[0], append(singleton(["Voornaam", NonEmptyString___UnsafeUnwrap_Z73AD07C(person.FirstName)]), delay(() => singleton(["Naam", NonEmptyString___UnsafeUnwrap_Z73AD07C(person.LastName)]))))) : ((company = matchValue_1.fields[0], append(singleton(["Bedrijfsnaam", NonEmptyString___UnsafeUnwrap_Z73AD07C(company.CompanyName)]), delay(() => singleton(["Bedrijfstype", defaultArg(map(NonEmptyString___UnsafeUnwrap_Z73AD07C, company.CompanyType), "-")])))))), delay(() => append(singleton(["Emailadres", Email___UnsafeUnwrap_Z27D11339(Customer2__get_Email(customer))]), delay(() => append(singleton(["Telefoon", defaultArg(map(PhoneNumber___UnsafeUnwrap_23E45174, Customer2__get_PhoneNumber(customer)), "-")]), delay(() => singleton(["Adres", Address_address(Customer2__get_Address(customer))])))))));
                            }
                        }
                    })),
                })]),
            })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])), delay(() => {
                let elems_1;
                return append(singleton(MuiHelpers_createElement(Paper, [Feliz_prop__prop_fss_Static_72C268A9(singleton_1(FlexClasses_FlexShrinkGrow__value_5E38073B(FlexGrow, 2))), (elems_1 = [createElement(Col, {
                    classes: empty(),
                    children: ofArray([createElement(InfoTitle, {
                        text: "Eigenaar",
                    }), MuiHelpers_createElement(Divider, []), createElement(DisplayData, {
                        data: toList(delay(() => {
                            const matchValue_5 = dossierData.DossierOwner;
                            if (matchValue_5.tag === 0) {
                                const person_3 = matchValue_5.fields[0];
                                return append(singleton(["Voornaam", NonEmptyString___UnsafeUnwrap_Z73AD07C(person_3.FirstName)]), delay(() => append(singleton(["Naam", NonEmptyString___UnsafeUnwrap_Z73AD07C(person_3.LastName)]), delay(() => append(singleton(["Emailadres", Email___UnsafeUnwrap_Z27D11339(person_3.Email)]), delay(() => append(singleton(["Telefoon", defaultArg(map(PhoneNumber___UnsafeUnwrap_23E45174, person_3.PhoneNumber), "-")]), delay(() => singleton(["Adres", Address_address(person_3.Address)])))))))));
                            }
                            else {
                                const company_3 = matchValue_5.fields[0];
                                return append(singleton(["Bedrijfsnaam", NonEmptyString___UnsafeUnwrap_Z73AD07C(company_3.CompanyName)]), delay(() => append(singleton(["Bedrijfstype", defaultArg(map(NonEmptyString___UnsafeUnwrap_Z73AD07C, company_3.CompanyType), "-")]), delay(() => append(singleton(["Emailadres", Email___UnsafeUnwrap_Z27D11339(company_3.Email)]), delay(() => append(singleton(["Telefoon", defaultArg(map(PhoneNumber___UnsafeUnwrap_23E45174, company_3.PhoneNumber), "-")]), delay(() => singleton(["Adres", Address_address(company_3.Address)])))))))));
                            }
                        })),
                    })]),
                })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])])), delay(() => {
                    let elems_2;
                    return append(singleton(MuiHelpers_createElement(Paper, [Feliz_prop__prop_fss_Static_72C268A9(singleton_1(FlexClasses_FlexShrinkGrow__value_5E38073B(FlexGrow, 3))), (elems_2 = [createElement(Col, {
                        classes: empty(),
                        children: ofArray([createElement(InfoTitle, {
                            text: "Inspectielocatie",
                        }), MuiHelpers_createElement(Divider, []), createElement(Row, {
                            classes: empty(),
                            children: ofArray([createElement(Col, {
                                classes: singleton_1(flexExpand),
                                children: singleton_1(createElement(DisplayData, {
                                    data: ofArray([["Type", InspectionLocation_type$0027(dossierData.InspectionLocation.Value)], ["Straat", NonEmptyString___UnsafeUnwrap_Z73AD07C(dossierData.Address.Street)], ["Nummer", NonEmptyString___UnsafeUnwrap_Z73AD07C(dossierData.Address.Number)], ["Bus", defaultArg(map(NonEmptyString___UnsafeUnwrap_Z73AD07C, dossierData.Address.Bus), "--")], ["Postcode", NonEmptyString___UnsafeUnwrap_Z73AD07C(dossierData.Address.PostalCode)], ["Gemeente", NonEmptyString___UnsafeUnwrap_Z73AD07C(dossierData.Address.City)]]),
                                })),
                            }), createElement(Col, {
                                classes: singleton_1(flexExpand),
                                children: singleton_1(createElement(DisplayData, {
                                    data: toList(delay(() => {
                                        let matchValue_6;
                                        return append((matchValue_6 = dossierData.InspectionLocation.Value, (matchValue_6.tag === 14) ? append(singleton(["Berging", defaultArg(map(NonEmptyString___UnsafeUnwrap_Z73AD07C, dossierData.ResidentialBerging), "0")]), delay(() => singleton(["Garagebox", defaultArg(map(NonEmptyString___UnsafeUnwrap_Z73AD07C, dossierData.ResidentialGaragebox), "0")]))) : ((matchValue_6.tag === 16) ? append(singleton(["Berging", defaultArg(map(NonEmptyString___UnsafeUnwrap_Z73AD07C, dossierData.ResidentialBerging), "0")]), delay(() => singleton(["Garagebox", defaultArg(map(NonEmptyString___UnsafeUnwrap_Z73AD07C, dossierData.ResidentialGaragebox), "0")]))) : ((matchValue_6.tag === 15) ? append(singleton(["Berging", defaultArg(map(NonEmptyString___UnsafeUnwrap_Z73AD07C, dossierData.ResidentialBerging), "0")]), delay(() => singleton(["Garagebox", defaultArg(map(NonEmptyString___UnsafeUnwrap_Z73AD07C, dossierData.ResidentialGaragebox), "0")]))) : ((empty_1()))))), delay(() => {
                                            let matchValue_7;
                                            return append(singleton(["Gebouwdeel/Vleugel/Blok", (matchValue_7 = dossierData.BuildingDetail, (matchValue_7 == null) ? "-" : NonEmptyString___UnsafeUnwrap_Z73AD07C(matchValue_7))]), delay(() => {
                                                let matchValue_8;
                                                return append(singleton(["Wooneenheden", (matchValue_8 = dossierData.HousingUnit, (matchValue_8 == null) ? "-" : NonEmptyString___UnsafeUnwrap_Z73AD07C(matchValue_8))]), delay(() => {
                                                    let matchValue_9;
                                                    return append(singleton(["Jaar van constructie", (matchValue_9 = dossierData.YearsOfConstruction, (matchValue_9 == null) ? "-" : NonEmptyString___UnsafeUnwrap_Z73AD07C(matchValue_9))]), delay(() => {
                                                        let matchValue_10;
                                                        return append(singleton(["Jaar van renovatie", (matchValue_10 = dossierData.YearsOfRenovation, (matchValue_10 == null) ? "-" : NonEmptyString___UnsafeUnwrap_Z73AD07C(matchValue_10))]), delay(() => {
                                                            let matchValue_11;
                                                            return append(singleton(["Aantal ingangen in het gebouw", (matchValue_11 = dossierData.NumberOfEntrances, (matchValue_11 == null) ? "-" : NonEmptyString___UnsafeUnwrap_Z73AD07C(matchValue_11))]), delay(() => {
                                                                let matchValue_12;
                                                                return append(singleton(["Leidingisolatie (lopende meter)", (matchValue_12 = dossierData.PipeIsolationMeters, (matchValue_12 == null) ? "-" : NonEmptyString___UnsafeUnwrap_Z73AD07C(matchValue_12))]), delay(() => {
                                                                    let matchValue_13;
                                                                    return append(singleton(["Gangen per verdiep", (matchValue_13 = dossierData.HallwaysPerLevel, (matchValue_13 == null) ? "-" : NonEmptyString___UnsafeUnwrap_Z73AD07C(matchValue_13))]), delay(() => singleton(["Stooklokaal", createElement(CheckIcon, {
                                                                        props: [],
                                                                        value: dossierData.BoilerRoom,
                                                                    })])));
                                                                }));
                                                            }));
                                                        }));
                                                    }));
                                                }));
                                            }));
                                        }));
                                    })),
                                })),
                            })]),
                        })]),
                    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_2))])])), delay(() => {
                        let elems_3;
                        return append(singleton(MuiHelpers_createElement(Paper, [Feliz_prop__prop_fss_Static_72C268A9(singleton_1(FlexClasses_FlexShrinkGrow__value_5E38073B(FlexGrow, 3))), (elems_3 = [createElement(Col, {
                            classes: empty(),
                            children: ofArray([createElement(InfoTitle, {
                                text: "Communicatie en facturatie",
                            }), MuiHelpers_createElement(Divider, []), createElement(Row, {
                                classes: empty(),
                                children: singleton_1(createElement(Col, {
                                    classes: singleton_1(flexExpand),
                                    children: ofArray([createElement(DisplayData, {
                                        data: singleton_1(["Contact afspraak", HomeVisitContactModule_string(dossierDataContact.HomeVisitContact)]),
                                    }), MuiHelpers_createElement(Divider, []), createElement(InfoTitle, {
                                        text: "We versturen het asbestattest naar",
                                    }), createElement(DisplayData, {
                                        data: toList(delay(() => append(singleton([partnerName, CheckBox(dossierDataContact.CertificateEmailPartner)]), delay(() => append(singleton(["Klant", CheckBox(dossierDataContact.CertificateEmailClient)]), delay(() => {
                                            const matchValue_14 = dossierDataContact.CertificateCustomEmails;
                                            if (matchValue_14 != null) {
                                                return singleton(["Extra Emails", matchValue_14.Value]);
                                            }
                                            else {
                                                return empty_1();
                                            }
                                        })))))),
                                    }), createElement(DisplayData, {
                                        data: singleton_1(["Tarieven van prijzen", InvoicePricingModule_string(dossierDataContact.InvoicePricing)]),
                                    })]),
                                })),
                            })]),
                        })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_3))])])), delay(() => {
                            let elems_4;
                            if (isPartnerSelected) {
                                const matchValue_15 = dossierData.CompensationAmount;
                                if (matchValue_15 == null) {
                                    return singleton(null);
                                }
                                else {
                                    const p = matchValue_15;
                                    return singleton(MuiHelpers_createElement(Paper, [Feliz_prop__prop_fss_Static_72C268A9(singleton_1(FlexClasses_FlexShrinkGrow__value_5E38073B(FlexGrow, 3))), (elems_4 = [createElement(Col, {
                                        classes: empty(),
                                        children: ofArray([createElement(InfoTitle, {
                                            text: "Partner",
                                        }), MuiHelpers_createElement(Divider, []), createElement(Row, {
                                            classes: empty(),
                                            children: singleton_1(createElement(Col, {
                                                classes: singleton_1(flexExpand),
                                                children: singleton_1(createElement(DisplayData, {
                                                    data: singleton_1(["Vergoedingen", defaultArg(map(Compensation_compensation, dossierData.CompensationAmount), "-")]),
                                                })),
                                            })),
                                        })]),
                                    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_4))])]));
                                }
                            }
                            else {
                                return singleton(null);
                            }
                        }));
                    }));
                }));
            }));
        })),
    }))))))));
    return MuiHelpers_createElement(List, [["children", Interop_reactApi.Children.toArray(Array.from(children))]]);
}

export function CreateDossierForm(createDossierFormInputProps) {
    let matchValue, f1, f1_1, f1_2, f1_3, f1_4, f1_5, f1_6, f1_7, f1_8, f1_9, f1_10, f1_11, matchValue_2, v_19, v_20, matchValue_4, matchValue_18;
    const prefill = createDossierFormInputProps.prefill;
    const kind = createDossierFormInputProps.kind;
    const compensation = createDossierFormInputProps.compensation;
    const dossierCreatePageSource = createDossierFormInputProps.dossierCreatePageSource;
    const buttonRef = createDossierFormInputProps.buttonRef;
    const isCibDossier = createDossierFormInputProps.isCibDossier;
    const onCreateDossier = createDossierFormInputProps.onCreateDossier;
    const partners = createDossierFormInputProps.partners;
    const backUrl = createDossierFormInputProps.backUrl;
    const customerUrl = createDossierFormInputProps.customerUrl;
    const prefillData = map((tupledArg) => tupledArg[0].CreateDossierData, prefill);
    const pBind = (selector) => bind(selector, prefillData);
    const pVal = (selector_1, defaultV) => defaultArg(map(selector_1, prefillData), defaultV);
    const woonhuisBuildingForm = useFormField(pBind((d_1) => d_1.WoonhuisBuildingForm), some);
    const assignedAdiId = useFormField(pBind((d_2) => d_2.AssignedAdiId), some);
    const isPartner = (dossierCreatePageSource.tag === 2) ? true : (!(dossierCreatePageSource.tag === 0));
    const ownerStatusData = useFormField(map((d_3) => d_3.OwnerStatus.Value, prefillData), SelectOptionData$1_Create_Z510A3DC0);
    const ownerStatusOther = useFormField(defaultArg(map(NonEmptyString___UnsafeUnwrap_Z73AD07C, pBind((d_4) => d_4.OwnerStatusOther)), ""), NonEmptyString_get_Create());
    const buildingDetail = useFormField(defaultArg(map(NonEmptyString___UnsafeUnwrap_Z73AD07C, pBind((d_5) => d_5.BuildingDetail)), ""), EmptyString_get_Create());
    const dossierTypeData = useFormField((prefillData == null) ? ((isPartner ? true : equals(kind, new DossierKind(1))) ? (new TypeOfDossier_1(0, new AsbestInventory(0))) : (void 0)) : prefillData.TypeOfDossier.Value, TypeOfDossierData_Create_Z6219B46);
    const asbestInventoryData = useFormField((prefillData == null) ? ((isPartner ? true : equals(kind, new DossierKind(1))) ? (new AsbestInventory(0)) : (void 0)) : ((matchValue = prefillData.TypeOfDossier.Value, (matchValue.tag === 0) ? matchValue.fields[0] : ((isPartner ? true : equals(kind, new DossierKind(1))) ? (new AsbestInventory(0)) : (void 0)))), AsbestInventoryData_Create_7B10C0C6);
    const asbestInventoryOtherDescription = useFormField(defaultArg(map(NonEmptyString___UnsafeUnwrap_Z73AD07C, pBind((d_8) => d_8.AsbestInventoryOtherDescription)), ""), EmptyString_get_Create());
    const profile = isPartner ? (new AsbestInventoryProfile(ofSeq([new AsbestInventory(0), new AsbestInventory(10)], {
        Compare: compare,
    }))) : (new AsbestInventoryProfile(ofSeq(AsbestInventoryProfile_get_defaultInventory(), {
        Compare: compare,
    })));
    const inspectionLocationData = useFormField(map((d_9) => d_9.InspectionLocation.Value, prefillData), SelectOptionData$1_Create_Z510A3DC0);
    let inspectionLocationOtherStr;
    const matchValue_1 = map((d_10) => d_10.InspectionLocation.Value, prefillData);
    let pattern_matching_result, v_2, v_3, v_4, v_5;
    if (matchValue_1 != null) {
        if (matchValue_1.tag === 23) {
            pattern_matching_result = 0;
            v_2 = matchValue_1.fields[0];
        }
        else if (matchValue_1.tag === 12) {
            pattern_matching_result = 1;
            v_3 = matchValue_1.fields[0];
        }
        else if (matchValue_1.tag === 30) {
            pattern_matching_result = 2;
            v_4 = matchValue_1.fields[0];
        }
        else if (matchValue_1.tag === 3) {
            pattern_matching_result = 3;
            v_5 = matchValue_1.fields[0];
        }
        else {
            pattern_matching_result = 4;
        }
    }
    else {
        pattern_matching_result = 4;
    }
    switch (pattern_matching_result) {
        case 0: {
            inspectionLocationOtherStr = v_2.Value;
            break;
        }
        case 1: {
            inspectionLocationOtherStr = v_3.Value;
            break;
        }
        case 2: {
            inspectionLocationOtherStr = v_4.Value;
            break;
        }
        case 3: {
            inspectionLocationOtherStr = v_5.Value;
            break;
        }
        case 4: {
            inspectionLocationOtherStr = "";
            break;
        }
    }
    const residentialOther = useFormField(inspectionLocationOtherStr, NonEmptyString_get_Create());
    const nonResidentialOther = useFormField(inspectionLocationOtherStr, NonEmptyString_get_Create());
    const inSocialUseOther = useFormField(inspectionLocationOtherStr, NonEmptyString_get_Create());
    const publicOther = useFormField(inspectionLocationOtherStr, NonEmptyString_get_Create());
    const residentialBerging = useFormField(defaultArg(map((v_6) => v_6.Value, pBind((d_11) => d_11.ResidentialBerging)), "0"), NonEmptyString_get_Create());
    const residentialGaragebox = useFormField(defaultArg(map((v_7) => v_7.Value, pBind((d_12) => d_12.ResidentialGaragebox)), "0"), NonEmptyString_get_Create());
    const sharedAreaOption1 = useFormField(defaultArg(map((v_8) => v_8.Value, pBind((d_13) => d_13.SharedAreaOption1)), ""), (f1 = NonEmptyString_get_Create(), (arg_8) => some(f1(arg_8))));
    const sharedAreaOption2 = useFormField(defaultArg(map((v_9) => v_9.Value, pBind((d_14) => d_14.SharedAreaOption2)), ""), (f1_1 = NonEmptyString_get_Create(), (arg_10) => some(f1_1(arg_10))));
    const sharedAreaOption3 = useFormField(defaultArg(map((v_10) => v_10.Value, pBind((d_15) => d_15.SharedAreaOption3)), ""), (f1_2 = NonEmptyString_get_Create(), (arg_12) => some(f1_2(arg_12))));
    const sharedAreaOption4 = useFormField(defaultArg(map((v_11) => v_11.Value, pBind((d_16) => d_16.SharedAreaOption4)), ""), (f1_3 = NonEmptyString_get_Create(), (arg_14) => some(f1_3(arg_14))));
    const additionalGarage = useFormField(defaultArg(map((v_12) => v_12.Value, pBind((d_17) => d_17.AdditionalGarage)), ""), (f1_4 = NonEmptyString_get_Create(), (arg_16) => some(f1_4(arg_16))));
    const additionalGardenbox = useFormField(defaultArg(map((v_13) => v_13.Value, pBind((d_18) => d_18.AdditionalGardenbox)), ""), (f1_5 = NonEmptyString_get_Create(), (arg_18) => some(f1_5(arg_18))));
    const additionalGreenhouse = useFormField(defaultArg(map((v_14) => v_14.Value, pBind((d_19) => d_19.AdditionalGreenhouse)), ""), (f1_6 = NonEmptyString_get_Create(), (arg_20) => some(f1_6(arg_20))));
    const hasExistingAsbestosAttest = useFormField(pBind((d_20) => d_20.ExistingAsbestosAttest), SelectOptionData$1_Create_Z510A3DC0);
    const existingAsbestosAttestNumbers = useFormField(defaultArg(map((v_15) => v_15.Value, pBind((d_21) => d_21.ExistingAsbestosAttestNumbers)), ""), EmptyString_get_Create());
    const asbestosAttestSplit = useToggle(defaultArg(pBind((d_22) => d_22.ExistingAsbestosAttestSplit), false));
    const asbestosAttestExpired = useToggle(defaultArg(pBind((d_23) => d_23.ExistingAsbestosAttestExpired), false));
    const asbestosAttestMaterialChanged = useToggle(defaultArg(pBind((d_24) => d_24.ExistingAsbestosAttestMaterialChanged), false));
    const asbestosAttestRestrictionLifted = useToggle(defaultArg(pBind((d_25) => d_25.ExistingAsbestosAttestRestrictionLifted), false));
    const asbestosAttestOther = useToggle(defaultArg(pBind((d_26) => d_26.ExistingAsbestosAttestOther), false));
    const asbestosAttestOtherDescription = useFormField(defaultArg(map(NonEmptyString___UnsafeUnwrap_Z73AD07C, pBind((d_27) => d_27.ExistingAsbestosAttestOtherDescription)), ""), EmptyString_get_Create());
    const dossierClientData = useFormField((prefillData == null) ? (new DossierClient(0)) : prefillData.Client.Value, SelectOptionData$1_Create_Z510A3DC0);
    const isUserOwnerOfArea = useFormField(map((d_29) => d_29.IsUserOwnerOfInspectionArea, prefillData), SelectOptionData$1_Create_Z510A3DC0);
    const yearOfConstruction = useFormField(defaultArg(map(NonEmptyString___UnsafeUnwrap_Z73AD07C, pBind((d_30) => d_30.YearsOfConstruction)), ""), (f1_7 = NonEmptyString_get_Create(), (arg_27) => some(f1_7(arg_27))));
    const yearOfRenovation = useFormField(defaultArg(map(NonEmptyString___UnsafeUnwrap_Z73AD07C, pBind((d_31) => d_31.YearsOfRenovation)), ""), (f1_8 = NonEmptyString_get_Create(), (arg_30) => some(f1_8(arg_30))));
    const numberOfEntrances = useFormField(defaultArg(map((v_16) => v_16.Value, pBind((d_32) => d_32.NumberOfEntrances)), ""), (f1_9 = NonEmptyString_get_Create(), (arg_32) => some(f1_9(arg_32))));
    const boilerRoom = useToggle(pVal((d_33) => d_33.BoilerRoom, false));
    const pipleIsolationMeters = useFormField(defaultArg(map((v_17) => v_17.Value, pBind((d_34) => d_34.PipeIsolationMeters)), ""), (f1_10 = NonEmptyString_get_Create(), (arg_34) => some(f1_10(arg_34))));
    const hallwaysPerLevel = useFormField(defaultArg(map((v_18) => v_18.Value, pBind((d_35) => d_35.HallwaysPerLevel)), ""), (f1_11 = NonEmptyString_get_Create(), (arg_36) => some(f1_11(arg_36))));
    const discount = useFormField((matchValue_2 = map((d_36) => d_36.Discount, prefillData), (matchValue_2 != null) ? ((matchValue_2.tag === 1) ? ((v_19 = matchValue_2.fields[0], `${v_19}`)) : ((matchValue_2.tag === 2) ? ((v_20 = matchValue_2.fields[0], `${v_20}`)) : "0")) : "0"), ParseNonNegative);
    let addressCase;
    let patternInput;
    const matchValue_3 = map((d_37) => d_37.Address, prefillData);
    if (matchValue_3 == null) {
        patternInput = ["", "", "", "", ""];
    }
    else {
        const addr = matchValue_3;
        const bus = defaultArg(map(NonEmptyString___UnsafeUnwrap_Z73AD07C, addr.Bus), "");
        patternInput = [NonEmptyString___UnsafeUnwrap_Z73AD07C(addr.Street), NonEmptyString___UnsafeUnwrap_Z73AD07C(addr.Number), bus, NonEmptyString___UnsafeUnwrap_Z73AD07C(addr.PostalCode), NonEmptyString___UnsafeUnwrap_Z73AD07C(addr.City)];
    }
    addressCase = useAddressForm(patternInput[0], patternInput[1], patternInput[2], patternInput[3], patternInput[4]);
    const sendMailToPartner = useToggle(true);
    const manualInvoice = useToggle(pVal((d_38) => d_38.ManualInvoice, true));
    const allowInvoice = useToggle(pVal((d_39) => d_39.AllowInvoice, true));
    const yearOfConstructionRequiredError = useFeliz_React__React_useState_Static_1505(false)[0];
    const patternInput_2 = useFeliz_React__React_useState_Static_1505(false);
    const patternInput_3 = useFeliz_React__React_useState_Static_1505(isCibDossier);
    const prefillOwner = map((d_40) => d_40.DossierOwner, prefillData);
    const ownerOption = useFormField((prefillOwner == null) ? (void 0) : ((prefillOwner.tag === 0) ? (new ContactOwner(0)) : (new ContactOwner(1))), SelectOptionData$1_Create_Z510A3DC0);
    let ownerCompany;
    let patternInput_4;
    let pattern_matching_result_1, c;
    if (prefillOwner != null) {
        if (prefillOwner.tag === 1) {
            pattern_matching_result_1 = 0;
            c = prefillOwner.fields[0];
        }
        else {
            pattern_matching_result_1 = 1;
        }
    }
    else {
        pattern_matching_result_1 = 1;
    }
    switch (pattern_matching_result_1) {
        case 0: {
            const bus_1 = defaultArg(map(NonEmptyString___UnsafeUnwrap_Z73AD07C, c.Address.Bus), "");
            const companyType = defaultArg(map(NonEmptyString___UnsafeUnwrap_Z73AD07C, c.CompanyType), "");
            const phone = defaultArg(map(PhoneNumber___UnsafeUnwrap_23E45174, c.PhoneNumber), "");
            const firstName = defaultArg(map(NonEmptyString___UnsafeUnwrap_Z73AD07C, c.FirstName), "");
            const lastName = defaultArg(map(NonEmptyString___UnsafeUnwrap_Z73AD07C, c.LastName), "");
            patternInput_4 = [c.CompanyName.Value, companyType, Email___UnsafeUnwrap_Z27D11339(c.Email), phone, c.VatNumber.Value, NonEmptyString___UnsafeUnwrap_Z73AD07C(c.Address.Street), NonEmptyString___UnsafeUnwrap_Z73AD07C(c.Address.Number), bus_1, NonEmptyString___UnsafeUnwrap_Z73AD07C(c.Address.PostalCode), NonEmptyString___UnsafeUnwrap_Z73AD07C(c.Address.City), c.IsVME, c.IsSocialHousingCompany, firstName, lastName];
            break;
        }
        case 1: {
            patternInput_4 = ["", "", "", "", "", "", "", "", "", "", false, false, "", ""];
            break;
        }
    }
    ownerCompany = useCreateDossierOwnerCompanyForm(patternInput_4[0], patternInput_4[1], patternInput_4[2], patternInput_4[3], patternInput_4[4], patternInput_4[5], patternInput_4[6], patternInput_4[7], patternInput_4[8], patternInput_4[9], patternInput_4[10], patternInput_4[11], patternInput_4[12], patternInput_4[13]);
    let ownerPerson;
    let patternInput_5;
    let pattern_matching_result_2, p;
    if (prefillOwner != null) {
        if (prefillOwner.tag === 0) {
            pattern_matching_result_2 = 0;
            p = prefillOwner.fields[0];
        }
        else {
            pattern_matching_result_2 = 1;
        }
    }
    else {
        pattern_matching_result_2 = 1;
    }
    switch (pattern_matching_result_2) {
        case 0: {
            const bus_3 = defaultArg(map(NonEmptyString___UnsafeUnwrap_Z73AD07C, p.Address.Bus), "");
            const phone_2 = defaultArg(map(PhoneNumber___UnsafeUnwrap_23E45174, p.PhoneNumber), "");
            patternInput_5 = [p.FirstName.Value, p.LastName.Value, Email___UnsafeUnwrap_Z27D11339(p.Email), phone_2, NonEmptyString___UnsafeUnwrap_Z73AD07C(p.Address.Street), NonEmptyString___UnsafeUnwrap_Z73AD07C(p.Address.Number), bus_3, NonEmptyString___UnsafeUnwrap_Z73AD07C(p.Address.PostalCode), NonEmptyString___UnsafeUnwrap_Z73AD07C(p.Address.City)];
            break;
        }
        case 1: {
            patternInput_5 = ["", "", "", "", "", "", "", "", ""];
            break;
        }
    }
    ownerPerson = useCreateDossierOwnerPersonForm(patternInput_5[0], patternInput_5[1], patternInput_5[2], patternInput_5[3], patternInput_5[4], patternInput_5[5], patternInput_5[6], patternInput_5[7], patternInput_5[8]);
    const patternInput_6 = useFeliz_React__React_useState_Static_1505(void 0);
    const inspectionLocationBerging = useToggle(defaultArg(pBind((d_41) => d_41.InspectionLocationBerging), false));
    const inspectionLocationStaanplaats = useToggle(defaultArg(pBind((d_42) => d_42.InspectionLocationStaanplaats), false));
    const inspectionLocationGaragebox = useToggle(defaultArg(pBind((d_43) => d_43.InspectionLocationGaragebox), false));
    const compensationData = useFormField((matchValue_4 = pBind((d_44) => d_44.CompensationAmount), (matchValue_4 == null) ? compensation : matchValue_4), SelectOptionData$1_Create_Z510A3DC0);
    let compensationCustomAmt;
    const matchValue_5 = compensationData.FieldValue;
    if (matchValue_5 == null) {
        compensationCustomAmt = Compensation_fromDomain(Compensation_get_DefaultCompensation());
    }
    else {
        const c_2 = matchValue_5;
        compensationCustomAmt = ((c_2.tag === 11) ? c_2.fields[0].Value : Compensation_fromDomain(Compensation_get_DefaultCompensation()));
    }
    const compensationCustom = useFormField(compensationCustomAmt, Decimal_get_Create());
    const compensationCustom_1 = useFormField(compensationCustomAmt, Decimal_get_Create());
    const patternInput_7 = useFeliz_React__React_useState_Static_1505(false);
    const isSameAddress = patternInput_7[0];
    const patternInput_8 = useFeliz_React__React_useState_Static_1505(false);
    const setDisable = patternInput_8[1];
    const disable = patternInput_8[0];
    const patternInput_9 = useFeliz_React__React_useState_Static_1505((partners == null) ? PartnerOption_get_none() : PartnerOption_get_empty());
    const setPartnerOption = patternInput_9[1];
    const partnerOption = patternInput_9[0];
    const patternInput_10 = useFeliz_React__React_useState_Static_1505(false);
    const setSelectPartnerError = patternInput_10[1];
    const selectPartnerError = patternInput_10[0];
    const patternInput_11 = useFeliz_React__React_useState_Static_1505(false);
    const setPrefillPartnerSeeded = patternInput_11[1];
    useReact_useEffect_Z101E1A95(() => {
        const matchValue_6 = [prefill, partners, patternInput_11[0]];
        let pattern_matching_result_3, list, partner;
        if (matchValue_6[0] != null) {
            if (matchValue_6[0][2] == null) {
                if (matchValue_6[2]) {
                    pattern_matching_result_3 = 2;
                }
                else {
                    pattern_matching_result_3 = 1;
                }
            }
            else if (matchValue_6[1] != null) {
                if (matchValue_6[2]) {
                    pattern_matching_result_3 = 2;
                }
                else {
                    pattern_matching_result_3 = 0;
                    list = matchValue_6[1];
                    partner = matchValue_6[0][2];
                }
            }
            else {
                pattern_matching_result_3 = 2;
            }
        }
        else {
            pattern_matching_result_3 = 2;
        }
        switch (pattern_matching_result_3) {
            case 0: {
                const matched = tryFind((p_1) => equals(p_1.Id, partner.Id), list);
                if (matched == null) {
                    setPartnerOption(PartnerOption_get_none());
                    setPrefillPartnerSeeded(true);
                }
                else {
                    const p_2 = matched;
                    setPartnerOption(new PartnerOption(NonEmptyString___UnsafeUnwrap_Z73AD07C(p_2.CompanyName), p_2.Id.Value, p_2.IsCibPartner, p_2.PartnerType, p_2.CompensationAmount, p_2.CompensationAmountEpc));
                    setPrefillPartnerSeeded(true);
                }
                break;
            }
            case 1: {
                setPartnerOption(PartnerOption_get_none());
                setPrefillPartnerSeeded(true);
                break;
            }
            case 2: {
                break;
            }
        }
    }, [partners, prefill]);
    const optionalNonEmptyString = (value_35) => {
        if (isNullOrWhiteSpace(value_35)) {
            return void 0;
        }
        else {
            return NonEmptyString___UnsafeCreate_Z721C83C5(value_35);
        }
    };
    useReact_useEffect_Z101E1A95(() => {
        const matchValue_7 = ownerOption.FieldValue;
        if (matchValue_7 != null) {
            if (matchValue_7.tag === 1) {
                if (ownerCompany.Social.State) {
                    ownerStatusData.SetFieldValue(new OwnerStatus_2(1));
                }
                else {
                    ownerStatusData.SetFieldValue(new OwnerStatus_2(6));
                }
            }
            else {
                ownerStatusData.SetFieldValue(new OwnerStatus_2(0));
            }
        }
    }, [ownerOption.FieldValue, ownerCompany.Social.State]);
    useReact_useEffect_Z101E1A95(() => {
        if (equals(partnerOption, PartnerOption_get_empty()) ? true : equals(partnerOption, PartnerOption_get_none())) {
        }
        else {
            const partnerCompensation = (kind.tag === 0) ? partnerOption.CompensationAmount : partnerOption.CompensationAmountEpc;
            const compensationAmt = (partnerCompensation == null) ? Compensation_get_DefaultCompensation() : partnerCompensation;
            let compensationCustomAmt_1;
            if (partnerCompensation == null) {
                compensationCustomAmt_1 = Compensation_fromDomain(Compensation_get_DefaultCompensation());
            }
            else {
                const c_4 = partnerCompensation;
                compensationCustomAmt_1 = ((c_4.tag === 11) ? c_4.fields[0].Value : Compensation_fromDomain(Compensation_get_DefaultCompensation()));
            }
            compensationData.SetFieldValue(compensationAmt);
            compensationCustom_1.SetFieldValue(compensationCustomAmt_1);
        }
    }, [partnerOption]);
    const validateOther = (r, otherFormField) => {
        const matchValue_8 = useFormValidator(otherFormField.Validator, (unitVar_3, y_2) => ({
            Other: y_2,
        }), useForm()).Validate();
        if (matchValue_8 == null) {
            return void 0;
        }
        else {
            return matchValue_8.Other;
        }
    };
    const form = useFormValidator(compensationData.Validator, (r_22, x_24) => {
        if (x_24.Value.tag === 11) {
            if (compare_1(compensationCustom_1.FieldValue, fromParts(0, 0, 0, false, 0)) > 0) {
                return {
                    AdditionalGarage: r_22.AdditionalGarage,
                    AdditionalGardenbox: r_22.AdditionalGardenbox,
                    AdditionalGreenhouse: r_22.AdditionalGreenhouse,
                    Address: r_22.Address,
                    BuildingDetail: r_22.BuildingDetail,
                    Compensation: new Compensation_3(11, Decimal___UnsafeCreate_32C73145(compensationCustom_1.FieldValue)),
                    Discount: r_22.Discount,
                    DossierClient: r_22.DossierClient,
                    DossierOwner: r_22.DossierOwner,
                    DossierType: r_22.DossierType,
                    HallwaysPerLevel: r_22.HallwaysPerLevel,
                    InspectionLocation: r_22.InspectionLocation,
                    InspectionLocationBerging: r_22.InspectionLocationBerging,
                    InspectionLocationGaragebox: r_22.InspectionLocationGaragebox,
                    InspectionLocationOther: r_22.InspectionLocationOther,
                    InspectionLocationStaanplaats: r_22.InspectionLocationStaanplaats,
                    IsUserOwnerOfArea: r_22.IsUserOwnerOfArea,
                    NumberOfEntrances: r_22.NumberOfEntrances,
                    OwnerStatus: r_22.OwnerStatus,
                    OwnerStatusOther: r_22.OwnerStatusOther,
                    PipeIsolationMeters: r_22.PipeIsolationMeters,
                    ResidentialBerging: r_22.ResidentialBerging,
                    ResidentialGarageBox: r_22.ResidentialGarageBox,
                    SharedAreaOption1: r_22.SharedAreaOption1,
                    SharedAreaOption2: r_22.SharedAreaOption2,
                    SharedAreaOption3: r_22.SharedAreaOption3,
                    SharedAreaOption4: r_22.SharedAreaOption4,
                    YearOfRenovation: r_22.YearOfRenovation,
                    YearsOfConstruction: r_22.YearsOfConstruction,
                };
            }
            else {
                return {
                    AdditionalGarage: r_22.AdditionalGarage,
                    AdditionalGardenbox: r_22.AdditionalGardenbox,
                    AdditionalGreenhouse: r_22.AdditionalGreenhouse,
                    Address: r_22.Address,
                    BuildingDetail: r_22.BuildingDetail,
                    Compensation: void 0,
                    Discount: r_22.Discount,
                    DossierClient: r_22.DossierClient,
                    DossierOwner: r_22.DossierOwner,
                    DossierType: r_22.DossierType,
                    HallwaysPerLevel: r_22.HallwaysPerLevel,
                    InspectionLocation: r_22.InspectionLocation,
                    InspectionLocationBerging: r_22.InspectionLocationBerging,
                    InspectionLocationGaragebox: r_22.InspectionLocationGaragebox,
                    InspectionLocationOther: r_22.InspectionLocationOther,
                    InspectionLocationStaanplaats: r_22.InspectionLocationStaanplaats,
                    IsUserOwnerOfArea: r_22.IsUserOwnerOfArea,
                    NumberOfEntrances: r_22.NumberOfEntrances,
                    OwnerStatus: r_22.OwnerStatus,
                    OwnerStatusOther: r_22.OwnerStatusOther,
                    PipeIsolationMeters: r_22.PipeIsolationMeters,
                    ResidentialBerging: r_22.ResidentialBerging,
                    ResidentialGarageBox: r_22.ResidentialGarageBox,
                    SharedAreaOption1: r_22.SharedAreaOption1,
                    SharedAreaOption2: r_22.SharedAreaOption2,
                    SharedAreaOption3: r_22.SharedAreaOption3,
                    SharedAreaOption4: r_22.SharedAreaOption4,
                    YearOfRenovation: r_22.YearOfRenovation,
                    YearsOfConstruction: r_22.YearsOfConstruction,
                };
            }
        }
        else {
            return {
                AdditionalGarage: r_22.AdditionalGarage,
                AdditionalGardenbox: r_22.AdditionalGardenbox,
                AdditionalGreenhouse: r_22.AdditionalGreenhouse,
                Address: r_22.Address,
                BuildingDetail: r_22.BuildingDetail,
                Compensation: x_24.Value,
                Discount: r_22.Discount,
                DossierClient: r_22.DossierClient,
                DossierOwner: r_22.DossierOwner,
                DossierType: r_22.DossierType,
                HallwaysPerLevel: r_22.HallwaysPerLevel,
                InspectionLocation: r_22.InspectionLocation,
                InspectionLocationBerging: r_22.InspectionLocationBerging,
                InspectionLocationGaragebox: r_22.InspectionLocationGaragebox,
                InspectionLocationOther: r_22.InspectionLocationOther,
                InspectionLocationStaanplaats: r_22.InspectionLocationStaanplaats,
                IsUserOwnerOfArea: r_22.IsUserOwnerOfArea,
                NumberOfEntrances: r_22.NumberOfEntrances,
                OwnerStatus: r_22.OwnerStatus,
                OwnerStatusOther: r_22.OwnerStatusOther,
                PipeIsolationMeters: r_22.PipeIsolationMeters,
                ResidentialBerging: r_22.ResidentialBerging,
                ResidentialGarageBox: r_22.ResidentialGarageBox,
                SharedAreaOption1: r_22.SharedAreaOption1,
                SharedAreaOption2: r_22.SharedAreaOption2,
                SharedAreaOption3: r_22.SharedAreaOption3,
                SharedAreaOption4: r_22.SharedAreaOption4,
                YearOfRenovation: r_22.YearOfRenovation,
                YearsOfConstruction: r_22.YearsOfConstruction,
            };
        }
    }, useFormValidator(ownerStatusData.Validator, (r_21, x_23) => {
        if (x_23.Value.tag === 8) {
            const matchValue_16 = useFormValidator(ownerStatusOther.Validator, (unitVar_9, y_6) => ({
                OwnerStatusOther: y_6,
            }), useForm()).Validate();
            if (matchValue_16 == null) {
                return {
                    AdditionalGarage: r_21.AdditionalGarage,
                    AdditionalGardenbox: r_21.AdditionalGardenbox,
                    AdditionalGreenhouse: r_21.AdditionalGreenhouse,
                    Address: r_21.Address,
                    BuildingDetail: r_21.BuildingDetail,
                    Discount: r_21.Discount,
                    DossierClient: r_21.DossierClient,
                    DossierOwner: r_21.DossierOwner,
                    DossierType: r_21.DossierType,
                    HallwaysPerLevel: r_21.HallwaysPerLevel,
                    InspectionLocation: r_21.InspectionLocation,
                    InspectionLocationBerging: r_21.InspectionLocationBerging,
                    InspectionLocationGaragebox: r_21.InspectionLocationGaragebox,
                    InspectionLocationOther: r_21.InspectionLocationOther,
                    InspectionLocationStaanplaats: r_21.InspectionLocationStaanplaats,
                    IsUserOwnerOfArea: r_21.IsUserOwnerOfArea,
                    NumberOfEntrances: r_21.NumberOfEntrances,
                    OwnerStatus: x_23,
                    OwnerStatusOther: void 0,
                    PipeIsolationMeters: r_21.PipeIsolationMeters,
                    ResidentialBerging: r_21.ResidentialBerging,
                    ResidentialGarageBox: r_21.ResidentialGarageBox,
                    SharedAreaOption1: r_21.SharedAreaOption1,
                    SharedAreaOption2: r_21.SharedAreaOption2,
                    SharedAreaOption3: r_21.SharedAreaOption3,
                    SharedAreaOption4: r_21.SharedAreaOption4,
                    YearOfRenovation: r_21.YearOfRenovation,
                    YearsOfConstruction: r_21.YearsOfConstruction,
                };
            }
            else {
                return {
                    AdditionalGarage: r_21.AdditionalGarage,
                    AdditionalGardenbox: r_21.AdditionalGardenbox,
                    AdditionalGreenhouse: r_21.AdditionalGreenhouse,
                    Address: r_21.Address,
                    BuildingDetail: r_21.BuildingDetail,
                    Discount: r_21.Discount,
                    DossierClient: r_21.DossierClient,
                    DossierOwner: r_21.DossierOwner,
                    DossierType: r_21.DossierType,
                    HallwaysPerLevel: r_21.HallwaysPerLevel,
                    InspectionLocation: r_21.InspectionLocation,
                    InspectionLocationBerging: r_21.InspectionLocationBerging,
                    InspectionLocationGaragebox: r_21.InspectionLocationGaragebox,
                    InspectionLocationOther: r_21.InspectionLocationOther,
                    InspectionLocationStaanplaats: r_21.InspectionLocationStaanplaats,
                    IsUserOwnerOfArea: r_21.IsUserOwnerOfArea,
                    NumberOfEntrances: r_21.NumberOfEntrances,
                    OwnerStatus: x_23,
                    OwnerStatusOther: matchValue_16.OwnerStatusOther,
                    PipeIsolationMeters: r_21.PipeIsolationMeters,
                    ResidentialBerging: r_21.ResidentialBerging,
                    ResidentialGarageBox: r_21.ResidentialGarageBox,
                    SharedAreaOption1: r_21.SharedAreaOption1,
                    SharedAreaOption2: r_21.SharedAreaOption2,
                    SharedAreaOption3: r_21.SharedAreaOption3,
                    SharedAreaOption4: r_21.SharedAreaOption4,
                    YearOfRenovation: r_21.YearOfRenovation,
                    YearsOfConstruction: r_21.YearsOfConstruction,
                };
            }
        }
        else {
            return {
                AdditionalGarage: r_21.AdditionalGarage,
                AdditionalGardenbox: r_21.AdditionalGardenbox,
                AdditionalGreenhouse: r_21.AdditionalGreenhouse,
                Address: r_21.Address,
                BuildingDetail: r_21.BuildingDetail,
                Discount: r_21.Discount,
                DossierClient: r_21.DossierClient,
                DossierOwner: r_21.DossierOwner,
                DossierType: r_21.DossierType,
                HallwaysPerLevel: r_21.HallwaysPerLevel,
                InspectionLocation: r_21.InspectionLocation,
                InspectionLocationBerging: r_21.InspectionLocationBerging,
                InspectionLocationGaragebox: r_21.InspectionLocationGaragebox,
                InspectionLocationOther: r_21.InspectionLocationOther,
                InspectionLocationStaanplaats: r_21.InspectionLocationStaanplaats,
                IsUserOwnerOfArea: r_21.IsUserOwnerOfArea,
                NumberOfEntrances: r_21.NumberOfEntrances,
                OwnerStatus: x_23,
                OwnerStatusOther: void 0,
                PipeIsolationMeters: r_21.PipeIsolationMeters,
                ResidentialBerging: r_21.ResidentialBerging,
                ResidentialGarageBox: r_21.ResidentialGarageBox,
                SharedAreaOption1: r_21.SharedAreaOption1,
                SharedAreaOption2: r_21.SharedAreaOption2,
                SharedAreaOption3: r_21.SharedAreaOption3,
                SharedAreaOption4: r_21.SharedAreaOption4,
                YearOfRenovation: r_21.YearOfRenovation,
                YearsOfConstruction: r_21.YearsOfConstruction,
            };
        }
    }, useFormValidator(ownerOption.Validator, (r_20, x_22) => {
        if (x_22.Value.tag === 0) {
            const matchValue_14 = useFormValidator(ownerPerson.Validator, (unitVar_8, y_5) => ({
                DossierOwner: new DossierOwner_4(0, y_5),
            }), useForm()).Validate();
            if (matchValue_14 == null) {
                return {
                    AdditionalGarage: r_20.AdditionalGarage,
                    AdditionalGardenbox: r_20.AdditionalGardenbox,
                    AdditionalGreenhouse: r_20.AdditionalGreenhouse,
                    Address: r_20.Address,
                    BuildingDetail: r_20.BuildingDetail,
                    Discount: r_20.Discount,
                    DossierClient: r_20.DossierClient,
                    DossierOwner: void 0,
                    DossierType: r_20.DossierType,
                    HallwaysPerLevel: r_20.HallwaysPerLevel,
                    InspectionLocation: r_20.InspectionLocation,
                    InspectionLocationBerging: r_20.InspectionLocationBerging,
                    InspectionLocationGaragebox: r_20.InspectionLocationGaragebox,
                    InspectionLocationOther: r_20.InspectionLocationOther,
                    InspectionLocationStaanplaats: r_20.InspectionLocationStaanplaats,
                    IsUserOwnerOfArea: r_20.IsUserOwnerOfArea,
                    NumberOfEntrances: r_20.NumberOfEntrances,
                    OwnerStatus: r_20.OwnerStatus,
                    PipeIsolationMeters: r_20.PipeIsolationMeters,
                    ResidentialBerging: r_20.ResidentialBerging,
                    ResidentialGarageBox: r_20.ResidentialGarageBox,
                    SharedAreaOption1: r_20.SharedAreaOption1,
                    SharedAreaOption2: r_20.SharedAreaOption2,
                    SharedAreaOption3: r_20.SharedAreaOption3,
                    SharedAreaOption4: r_20.SharedAreaOption4,
                    YearOfRenovation: r_20.YearOfRenovation,
                    YearsOfConstruction: r_20.YearsOfConstruction,
                };
            }
            else {
                return {
                    AdditionalGarage: r_20.AdditionalGarage,
                    AdditionalGardenbox: r_20.AdditionalGardenbox,
                    AdditionalGreenhouse: r_20.AdditionalGreenhouse,
                    Address: r_20.Address,
                    BuildingDetail: r_20.BuildingDetail,
                    Discount: r_20.Discount,
                    DossierClient: r_20.DossierClient,
                    DossierOwner: matchValue_14.DossierOwner,
                    DossierType: r_20.DossierType,
                    HallwaysPerLevel: r_20.HallwaysPerLevel,
                    InspectionLocation: r_20.InspectionLocation,
                    InspectionLocationBerging: r_20.InspectionLocationBerging,
                    InspectionLocationGaragebox: r_20.InspectionLocationGaragebox,
                    InspectionLocationOther: r_20.InspectionLocationOther,
                    InspectionLocationStaanplaats: r_20.InspectionLocationStaanplaats,
                    IsUserOwnerOfArea: r_20.IsUserOwnerOfArea,
                    NumberOfEntrances: r_20.NumberOfEntrances,
                    OwnerStatus: r_20.OwnerStatus,
                    PipeIsolationMeters: r_20.PipeIsolationMeters,
                    ResidentialBerging: r_20.ResidentialBerging,
                    ResidentialGarageBox: r_20.ResidentialGarageBox,
                    SharedAreaOption1: r_20.SharedAreaOption1,
                    SharedAreaOption2: r_20.SharedAreaOption2,
                    SharedAreaOption3: r_20.SharedAreaOption3,
                    SharedAreaOption4: r_20.SharedAreaOption4,
                    YearOfRenovation: r_20.YearOfRenovation,
                    YearsOfConstruction: r_20.YearsOfConstruction,
                };
            }
        }
        else {
            const matchValue_13 = useFormValidator(ownerCompany.Validator, (unitVar_7, y_4) => ({
                DossierOwner: new DossierOwner_4(1, y_4),
            }), useForm()).Validate();
            if (matchValue_13 == null) {
                return {
                    AdditionalGarage: r_20.AdditionalGarage,
                    AdditionalGardenbox: r_20.AdditionalGardenbox,
                    AdditionalGreenhouse: r_20.AdditionalGreenhouse,
                    Address: r_20.Address,
                    BuildingDetail: r_20.BuildingDetail,
                    Discount: r_20.Discount,
                    DossierClient: r_20.DossierClient,
                    DossierOwner: void 0,
                    DossierType: r_20.DossierType,
                    HallwaysPerLevel: r_20.HallwaysPerLevel,
                    InspectionLocation: r_20.InspectionLocation,
                    InspectionLocationBerging: r_20.InspectionLocationBerging,
                    InspectionLocationGaragebox: r_20.InspectionLocationGaragebox,
                    InspectionLocationOther: r_20.InspectionLocationOther,
                    InspectionLocationStaanplaats: r_20.InspectionLocationStaanplaats,
                    IsUserOwnerOfArea: r_20.IsUserOwnerOfArea,
                    NumberOfEntrances: r_20.NumberOfEntrances,
                    OwnerStatus: r_20.OwnerStatus,
                    PipeIsolationMeters: r_20.PipeIsolationMeters,
                    ResidentialBerging: r_20.ResidentialBerging,
                    ResidentialGarageBox: r_20.ResidentialGarageBox,
                    SharedAreaOption1: r_20.SharedAreaOption1,
                    SharedAreaOption2: r_20.SharedAreaOption2,
                    SharedAreaOption3: r_20.SharedAreaOption3,
                    SharedAreaOption4: r_20.SharedAreaOption4,
                    YearOfRenovation: r_20.YearOfRenovation,
                    YearsOfConstruction: r_20.YearsOfConstruction,
                };
            }
            else {
                return {
                    AdditionalGarage: r_20.AdditionalGarage,
                    AdditionalGardenbox: r_20.AdditionalGardenbox,
                    AdditionalGreenhouse: r_20.AdditionalGreenhouse,
                    Address: r_20.Address,
                    BuildingDetail: r_20.BuildingDetail,
                    Discount: r_20.Discount,
                    DossierClient: r_20.DossierClient,
                    DossierOwner: matchValue_13.DossierOwner,
                    DossierType: r_20.DossierType,
                    HallwaysPerLevel: r_20.HallwaysPerLevel,
                    InspectionLocation: r_20.InspectionLocation,
                    InspectionLocationBerging: r_20.InspectionLocationBerging,
                    InspectionLocationGaragebox: r_20.InspectionLocationGaragebox,
                    InspectionLocationOther: r_20.InspectionLocationOther,
                    InspectionLocationStaanplaats: r_20.InspectionLocationStaanplaats,
                    IsUserOwnerOfArea: r_20.IsUserOwnerOfArea,
                    NumberOfEntrances: r_20.NumberOfEntrances,
                    OwnerStatus: r_20.OwnerStatus,
                    PipeIsolationMeters: r_20.PipeIsolationMeters,
                    ResidentialBerging: r_20.ResidentialBerging,
                    ResidentialGarageBox: r_20.ResidentialGarageBox,
                    SharedAreaOption1: r_20.SharedAreaOption1,
                    SharedAreaOption2: r_20.SharedAreaOption2,
                    SharedAreaOption3: r_20.SharedAreaOption3,
                    SharedAreaOption4: r_20.SharedAreaOption4,
                    YearOfRenovation: r_20.YearOfRenovation,
                    YearsOfConstruction: r_20.YearsOfConstruction,
                };
            }
        }
    }, useFormValidator(additionalGreenhouse.Validator, (r_19, x_21) => ({
        AdditionalGarage: r_19.AdditionalGarage,
        AdditionalGardenbox: r_19.AdditionalGardenbox,
        AdditionalGreenhouse: x_21,
        Address: r_19.Address,
        BuildingDetail: r_19.BuildingDetail,
        Discount: r_19.Discount,
        DossierClient: r_19.DossierClient,
        DossierType: r_19.DossierType,
        HallwaysPerLevel: r_19.HallwaysPerLevel,
        InspectionLocation: r_19.InspectionLocation,
        InspectionLocationBerging: r_19.InspectionLocationBerging,
        InspectionLocationGaragebox: r_19.InspectionLocationGaragebox,
        InspectionLocationOther: r_19.InspectionLocationOther,
        InspectionLocationStaanplaats: r_19.InspectionLocationStaanplaats,
        IsUserOwnerOfArea: r_19.IsUserOwnerOfArea,
        NumberOfEntrances: r_19.NumberOfEntrances,
        OwnerStatus: r_19.OwnerStatus,
        PipeIsolationMeters: r_19.PipeIsolationMeters,
        ResidentialBerging: r_19.ResidentialBerging,
        ResidentialGarageBox: r_19.ResidentialGarageBox,
        SharedAreaOption1: r_19.SharedAreaOption1,
        SharedAreaOption2: r_19.SharedAreaOption2,
        SharedAreaOption3: r_19.SharedAreaOption3,
        SharedAreaOption4: r_19.SharedAreaOption4,
        YearOfRenovation: r_19.YearOfRenovation,
        YearsOfConstruction: r_19.YearsOfConstruction,
    }), useFormValidator(additionalGardenbox.Validator, (r_18, x_20) => ({
        AdditionalGarage: r_18.AdditionalGarage,
        AdditionalGardenbox: x_20,
        Address: r_18.Address,
        BuildingDetail: r_18.BuildingDetail,
        Discount: r_18.Discount,
        DossierClient: r_18.DossierClient,
        DossierType: r_18.DossierType,
        HallwaysPerLevel: r_18.HallwaysPerLevel,
        InspectionLocation: r_18.InspectionLocation,
        InspectionLocationBerging: r_18.InspectionLocationBerging,
        InspectionLocationGaragebox: r_18.InspectionLocationGaragebox,
        InspectionLocationOther: r_18.InspectionLocationOther,
        InspectionLocationStaanplaats: r_18.InspectionLocationStaanplaats,
        IsUserOwnerOfArea: r_18.IsUserOwnerOfArea,
        NumberOfEntrances: r_18.NumberOfEntrances,
        OwnerStatus: r_18.OwnerStatus,
        PipeIsolationMeters: r_18.PipeIsolationMeters,
        ResidentialBerging: r_18.ResidentialBerging,
        ResidentialGarageBox: r_18.ResidentialGarageBox,
        SharedAreaOption1: r_18.SharedAreaOption1,
        SharedAreaOption2: r_18.SharedAreaOption2,
        SharedAreaOption3: r_18.SharedAreaOption3,
        SharedAreaOption4: r_18.SharedAreaOption4,
        YearOfRenovation: r_18.YearOfRenovation,
        YearsOfConstruction: r_18.YearsOfConstruction,
    }), useFormValidator(additionalGarage.Validator, (r_17, x_19) => ({
        AdditionalGarage: x_19,
        Address: r_17.Address,
        BuildingDetail: r_17.BuildingDetail,
        Discount: r_17.Discount,
        DossierClient: r_17.DossierClient,
        DossierType: r_17.DossierType,
        HallwaysPerLevel: r_17.HallwaysPerLevel,
        InspectionLocation: r_17.InspectionLocation,
        InspectionLocationBerging: r_17.InspectionLocationBerging,
        InspectionLocationGaragebox: r_17.InspectionLocationGaragebox,
        InspectionLocationOther: r_17.InspectionLocationOther,
        InspectionLocationStaanplaats: r_17.InspectionLocationStaanplaats,
        IsUserOwnerOfArea: r_17.IsUserOwnerOfArea,
        NumberOfEntrances: r_17.NumberOfEntrances,
        OwnerStatus: r_17.OwnerStatus,
        PipeIsolationMeters: r_17.PipeIsolationMeters,
        ResidentialBerging: r_17.ResidentialBerging,
        ResidentialGarageBox: r_17.ResidentialGarageBox,
        SharedAreaOption1: r_17.SharedAreaOption1,
        SharedAreaOption2: r_17.SharedAreaOption2,
        SharedAreaOption3: r_17.SharedAreaOption3,
        SharedAreaOption4: r_17.SharedAreaOption4,
        YearOfRenovation: r_17.YearOfRenovation,
        YearsOfConstruction: r_17.YearsOfConstruction,
    }), useFormValidator(sharedAreaOption4.Validator, (r_16, x_18) => ({
        Address: r_16.Address,
        BuildingDetail: r_16.BuildingDetail,
        Discount: r_16.Discount,
        DossierClient: r_16.DossierClient,
        DossierType: r_16.DossierType,
        HallwaysPerLevel: r_16.HallwaysPerLevel,
        InspectionLocation: r_16.InspectionLocation,
        InspectionLocationBerging: r_16.InspectionLocationBerging,
        InspectionLocationGaragebox: r_16.InspectionLocationGaragebox,
        InspectionLocationOther: r_16.InspectionLocationOther,
        InspectionLocationStaanplaats: r_16.InspectionLocationStaanplaats,
        IsUserOwnerOfArea: r_16.IsUserOwnerOfArea,
        NumberOfEntrances: r_16.NumberOfEntrances,
        OwnerStatus: r_16.OwnerStatus,
        PipeIsolationMeters: r_16.PipeIsolationMeters,
        ResidentialBerging: r_16.ResidentialBerging,
        ResidentialGarageBox: r_16.ResidentialGarageBox,
        SharedAreaOption1: r_16.SharedAreaOption1,
        SharedAreaOption2: r_16.SharedAreaOption2,
        SharedAreaOption3: r_16.SharedAreaOption3,
        SharedAreaOption4: x_18,
        YearOfRenovation: r_16.YearOfRenovation,
        YearsOfConstruction: r_16.YearsOfConstruction,
    }), useFormValidator(sharedAreaOption3.Validator, (r_15, x_17) => ({
        Address: r_15.Address,
        BuildingDetail: r_15.BuildingDetail,
        Discount: r_15.Discount,
        DossierClient: r_15.DossierClient,
        DossierType: r_15.DossierType,
        HallwaysPerLevel: r_15.HallwaysPerLevel,
        InspectionLocation: r_15.InspectionLocation,
        InspectionLocationBerging: r_15.InspectionLocationBerging,
        InspectionLocationGaragebox: r_15.InspectionLocationGaragebox,
        InspectionLocationOther: r_15.InspectionLocationOther,
        InspectionLocationStaanplaats: r_15.InspectionLocationStaanplaats,
        IsUserOwnerOfArea: r_15.IsUserOwnerOfArea,
        NumberOfEntrances: r_15.NumberOfEntrances,
        OwnerStatus: r_15.OwnerStatus,
        PipeIsolationMeters: r_15.PipeIsolationMeters,
        ResidentialBerging: r_15.ResidentialBerging,
        ResidentialGarageBox: r_15.ResidentialGarageBox,
        SharedAreaOption1: r_15.SharedAreaOption1,
        SharedAreaOption2: r_15.SharedAreaOption2,
        SharedAreaOption3: x_17,
        YearOfRenovation: r_15.YearOfRenovation,
        YearsOfConstruction: r_15.YearsOfConstruction,
    }), useFormValidator(sharedAreaOption2.Validator, (r_14, x_16) => ({
        Address: r_14.Address,
        BuildingDetail: r_14.BuildingDetail,
        Discount: r_14.Discount,
        DossierClient: r_14.DossierClient,
        DossierType: r_14.DossierType,
        HallwaysPerLevel: r_14.HallwaysPerLevel,
        InspectionLocation: r_14.InspectionLocation,
        InspectionLocationBerging: r_14.InspectionLocationBerging,
        InspectionLocationGaragebox: r_14.InspectionLocationGaragebox,
        InspectionLocationOther: r_14.InspectionLocationOther,
        InspectionLocationStaanplaats: r_14.InspectionLocationStaanplaats,
        IsUserOwnerOfArea: r_14.IsUserOwnerOfArea,
        NumberOfEntrances: r_14.NumberOfEntrances,
        OwnerStatus: r_14.OwnerStatus,
        PipeIsolationMeters: r_14.PipeIsolationMeters,
        ResidentialBerging: r_14.ResidentialBerging,
        ResidentialGarageBox: r_14.ResidentialGarageBox,
        SharedAreaOption1: r_14.SharedAreaOption1,
        SharedAreaOption2: x_16,
        YearOfRenovation: r_14.YearOfRenovation,
        YearsOfConstruction: r_14.YearsOfConstruction,
    }), useFormValidator(sharedAreaOption1.Validator, (r_13, x_15) => ({
        Address: r_13.Address,
        BuildingDetail: r_13.BuildingDetail,
        Discount: r_13.Discount,
        DossierClient: r_13.DossierClient,
        DossierType: r_13.DossierType,
        HallwaysPerLevel: r_13.HallwaysPerLevel,
        InspectionLocation: r_13.InspectionLocation,
        InspectionLocationBerging: r_13.InspectionLocationBerging,
        InspectionLocationGaragebox: r_13.InspectionLocationGaragebox,
        InspectionLocationOther: r_13.InspectionLocationOther,
        InspectionLocationStaanplaats: r_13.InspectionLocationStaanplaats,
        IsUserOwnerOfArea: r_13.IsUserOwnerOfArea,
        NumberOfEntrances: r_13.NumberOfEntrances,
        OwnerStatus: r_13.OwnerStatus,
        PipeIsolationMeters: r_13.PipeIsolationMeters,
        ResidentialBerging: r_13.ResidentialBerging,
        ResidentialGarageBox: r_13.ResidentialGarageBox,
        SharedAreaOption1: x_15,
        YearOfRenovation: r_13.YearOfRenovation,
        YearsOfConstruction: r_13.YearsOfConstruction,
    }), useFormValidator(discount.Validator, (r_12, x_14) => ({
        Address: r_12.Address,
        BuildingDetail: r_12.BuildingDetail,
        Discount: x_14,
        DossierClient: r_12.DossierClient,
        DossierType: r_12.DossierType,
        HallwaysPerLevel: r_12.HallwaysPerLevel,
        InspectionLocation: r_12.InspectionLocation,
        InspectionLocationBerging: r_12.InspectionLocationBerging,
        InspectionLocationGaragebox: r_12.InspectionLocationGaragebox,
        InspectionLocationOther: r_12.InspectionLocationOther,
        InspectionLocationStaanplaats: r_12.InspectionLocationStaanplaats,
        IsUserOwnerOfArea: r_12.IsUserOwnerOfArea,
        NumberOfEntrances: r_12.NumberOfEntrances,
        OwnerStatus: r_12.OwnerStatus,
        PipeIsolationMeters: r_12.PipeIsolationMeters,
        ResidentialBerging: r_12.ResidentialBerging,
        ResidentialGarageBox: r_12.ResidentialGarageBox,
        YearOfRenovation: r_12.YearOfRenovation,
        YearsOfConstruction: r_12.YearsOfConstruction,
    }), useFormValidator(hallwaysPerLevel.Validator, (r_11, x_13) => ({
        Address: r_11.Address,
        BuildingDetail: r_11.BuildingDetail,
        DossierClient: r_11.DossierClient,
        DossierType: r_11.DossierType,
        HallwaysPerLevel: x_13,
        InspectionLocation: r_11.InspectionLocation,
        InspectionLocationBerging: r_11.InspectionLocationBerging,
        InspectionLocationGaragebox: r_11.InspectionLocationGaragebox,
        InspectionLocationOther: r_11.InspectionLocationOther,
        InspectionLocationStaanplaats: r_11.InspectionLocationStaanplaats,
        IsUserOwnerOfArea: r_11.IsUserOwnerOfArea,
        NumberOfEntrances: r_11.NumberOfEntrances,
        OwnerStatus: r_11.OwnerStatus,
        PipeIsolationMeters: r_11.PipeIsolationMeters,
        ResidentialBerging: r_11.ResidentialBerging,
        ResidentialGarageBox: r_11.ResidentialGarageBox,
        YearOfRenovation: r_11.YearOfRenovation,
        YearsOfConstruction: r_11.YearsOfConstruction,
    }), useFormValidator(pipleIsolationMeters.Validator, (r_10, x_12) => ({
        Address: r_10.Address,
        BuildingDetail: r_10.BuildingDetail,
        DossierClient: r_10.DossierClient,
        DossierType: r_10.DossierType,
        InspectionLocation: r_10.InspectionLocation,
        InspectionLocationBerging: r_10.InspectionLocationBerging,
        InspectionLocationGaragebox: r_10.InspectionLocationGaragebox,
        InspectionLocationOther: r_10.InspectionLocationOther,
        InspectionLocationStaanplaats: r_10.InspectionLocationStaanplaats,
        IsUserOwnerOfArea: r_10.IsUserOwnerOfArea,
        NumberOfEntrances: r_10.NumberOfEntrances,
        OwnerStatus: r_10.OwnerStatus,
        PipeIsolationMeters: x_12,
        ResidentialBerging: r_10.ResidentialBerging,
        ResidentialGarageBox: r_10.ResidentialGarageBox,
        YearOfRenovation: r_10.YearOfRenovation,
        YearsOfConstruction: r_10.YearsOfConstruction,
    }), useFormValidator(numberOfEntrances.Validator, (r_9, x_11) => ({
        Address: r_9.Address,
        BuildingDetail: r_9.BuildingDetail,
        DossierClient: r_9.DossierClient,
        DossierType: r_9.DossierType,
        InspectionLocation: r_9.InspectionLocation,
        InspectionLocationBerging: r_9.InspectionLocationBerging,
        InspectionLocationGaragebox: r_9.InspectionLocationGaragebox,
        InspectionLocationOther: r_9.InspectionLocationOther,
        InspectionLocationStaanplaats: r_9.InspectionLocationStaanplaats,
        IsUserOwnerOfArea: r_9.IsUserOwnerOfArea,
        NumberOfEntrances: x_11,
        OwnerStatus: r_9.OwnerStatus,
        ResidentialBerging: r_9.ResidentialBerging,
        ResidentialGarageBox: r_9.ResidentialGarageBox,
        YearOfRenovation: r_9.YearOfRenovation,
        YearsOfConstruction: r_9.YearsOfConstruction,
    }), useFormValidator(yearOfRenovation.Validator, (r_8, x_10) => ({
        Address: r_8.Address,
        BuildingDetail: r_8.BuildingDetail,
        DossierClient: r_8.DossierClient,
        DossierType: r_8.DossierType,
        InspectionLocation: r_8.InspectionLocation,
        InspectionLocationBerging: r_8.InspectionLocationBerging,
        InspectionLocationGaragebox: r_8.InspectionLocationGaragebox,
        InspectionLocationOther: r_8.InspectionLocationOther,
        InspectionLocationStaanplaats: r_8.InspectionLocationStaanplaats,
        IsUserOwnerOfArea: r_8.IsUserOwnerOfArea,
        OwnerStatus: r_8.OwnerStatus,
        ResidentialBerging: r_8.ResidentialBerging,
        ResidentialGarageBox: r_8.ResidentialGarageBox,
        YearOfRenovation: x_10,
        YearsOfConstruction: r_8.YearsOfConstruction,
    }), useFormValidator(yearOfConstruction.Validator, (r_7, x_9) => ({
        Address: r_7.Address,
        BuildingDetail: r_7.BuildingDetail,
        DossierClient: r_7.DossierClient,
        DossierType: r_7.DossierType,
        InspectionLocation: r_7.InspectionLocation,
        InspectionLocationBerging: r_7.InspectionLocationBerging,
        InspectionLocationGaragebox: r_7.InspectionLocationGaragebox,
        InspectionLocationOther: r_7.InspectionLocationOther,
        InspectionLocationStaanplaats: r_7.InspectionLocationStaanplaats,
        IsUserOwnerOfArea: r_7.IsUserOwnerOfArea,
        OwnerStatus: r_7.OwnerStatus,
        ResidentialBerging: r_7.ResidentialBerging,
        ResidentialGarageBox: r_7.ResidentialGarageBox,
        YearsOfConstruction: x_9,
    }), useFormValidator(isUserOwnerOfArea.Validator, (r_6, x_8) => ({
        Address: r_6.Address,
        BuildingDetail: r_6.BuildingDetail,
        DossierClient: r_6.DossierClient,
        DossierType: r_6.DossierType,
        InspectionLocation: r_6.InspectionLocation,
        InspectionLocationBerging: r_6.InspectionLocationBerging,
        InspectionLocationGaragebox: r_6.InspectionLocationGaragebox,
        InspectionLocationOther: r_6.InspectionLocationOther,
        InspectionLocationStaanplaats: r_6.InspectionLocationStaanplaats,
        IsUserOwnerOfArea: x_8,
        OwnerStatus: r_6.OwnerStatus,
        ResidentialBerging: r_6.ResidentialBerging,
        ResidentialGarageBox: r_6.ResidentialGarageBox,
    }), useFormValidator(addressCase.Validator, (r_5, x_7) => ({
        Address: x_7,
        BuildingDetail: r_5.BuildingDetail,
        DossierClient: r_5.DossierClient,
        DossierType: r_5.DossierType,
        InspectionLocation: r_5.InspectionLocation,
        InspectionLocationBerging: r_5.InspectionLocationBerging,
        InspectionLocationGaragebox: r_5.InspectionLocationGaragebox,
        InspectionLocationOther: r_5.InspectionLocationOther,
        InspectionLocationStaanplaats: r_5.InspectionLocationStaanplaats,
        OwnerStatus: r_5.OwnerStatus,
        ResidentialBerging: r_5.ResidentialBerging,
        ResidentialGarageBox: r_5.ResidentialGarageBox,
    }), useFormValidator(buildingDetail.Validator, (r_4, x_6) => ({
        BuildingDetail: isNullOrEmpty(x_6.Value) ? (void 0) : (new NonEmptyString(x_6.Value)),
        DossierClient: r_4.DossierClient,
        DossierType: r_4.DossierType,
        InspectionLocation: r_4.InspectionLocation,
        InspectionLocationBerging: r_4.InspectionLocationBerging,
        InspectionLocationGaragebox: r_4.InspectionLocationGaragebox,
        InspectionLocationOther: r_4.InspectionLocationOther,
        InspectionLocationStaanplaats: r_4.InspectionLocationStaanplaats,
        OwnerStatus: r_4.OwnerStatus,
        ResidentialBerging: r_4.ResidentialBerging,
        ResidentialGarageBox: r_4.ResidentialGarageBox,
    }), useFormValidator(dossierClientData.Validator, (r_3, x_5) => ({
        DossierClient: x_5,
        DossierType: r_3.DossierType,
        InspectionLocation: r_3.InspectionLocation,
        InspectionLocationBerging: r_3.InspectionLocationBerging,
        InspectionLocationGaragebox: r_3.InspectionLocationGaragebox,
        InspectionLocationOther: r_3.InspectionLocationOther,
        InspectionLocationStaanplaats: r_3.InspectionLocationStaanplaats,
        OwnerStatus: new OwnerStatus_2(8),
        ResidentialBerging: r_3.ResidentialBerging,
        ResidentialGarageBox: r_3.ResidentialGarageBox,
    }), useFormValidator(inspectionLocationData.Validator, (r_2, x_4) => {
        const matchValue_11 = x_4.Value;
        switch (matchValue_11.tag) {
            case 14:
            case 16:
            case 15: {
                toConsole(printf("berging %A garage %A"))(residentialBerging.Value)(residentialGaragebox.Value);
                return {
                    DossierType: r_2.DossierType,
                    InspectionLocation: x_4,
                    InspectionLocationBerging: inspectionLocationBerging.State,
                    InspectionLocationGaragebox: inspectionLocationGaragebox.State,
                    InspectionLocationOther: void 0,
                    InspectionLocationStaanplaats: inspectionLocationStaanplaats.State,
                    ResidentialBerging: validateOther(r_2, residentialBerging),
                    ResidentialGarageBox: validateOther(r_2, residentialGaragebox),
                };
            }
            case 23: {
                return {
                    DossierType: r_2.DossierType,
                    InspectionLocation: x_4,
                    InspectionLocationBerging: void 0,
                    InspectionLocationGaragebox: void 0,
                    InspectionLocationOther: validateOther(r_2, residentialOther),
                    InspectionLocationStaanplaats: void 0,
                    ResidentialBerging: void 0,
                    ResidentialGarageBox: void 0,
                };
            }
            case 12: {
                return {
                    DossierType: r_2.DossierType,
                    InspectionLocation: x_4,
                    InspectionLocationBerging: void 0,
                    InspectionLocationGaragebox: void 0,
                    InspectionLocationOther: validateOther(r_2, nonResidentialOther),
                    InspectionLocationStaanplaats: void 0,
                    ResidentialBerging: void 0,
                    ResidentialGarageBox: void 0,
                };
            }
            case 3: {
                return {
                    DossierType: r_2.DossierType,
                    InspectionLocation: x_4,
                    InspectionLocationBerging: void 0,
                    InspectionLocationGaragebox: void 0,
                    InspectionLocationOther: validateOther(r_2, publicOther),
                    InspectionLocationStaanplaats: void 0,
                    ResidentialBerging: void 0,
                    ResidentialGarageBox: void 0,
                };
            }
            case 30: {
                return {
                    DossierType: r_2.DossierType,
                    InspectionLocation: x_4,
                    InspectionLocationBerging: void 0,
                    InspectionLocationGaragebox: void 0,
                    InspectionLocationOther: validateOther(r_2, inSocialUseOther),
                    InspectionLocationStaanplaats: void 0,
                    ResidentialBerging: void 0,
                    ResidentialGarageBox: void 0,
                };
            }
            default: {
                return {
                    DossierType: r_2.DossierType,
                    InspectionLocation: x_4,
                    InspectionLocationBerging: void 0,
                    InspectionLocationGaragebox: void 0,
                    InspectionLocationOther: void 0,
                    InspectionLocationStaanplaats: void 0,
                    ResidentialBerging: void 0,
                    ResidentialGarageBox: void 0,
                };
            }
        }
    }, useFormValidator(dossierTypeData.Validator, (unitVar_5, x_2) => {
        if (x_2.Value.tag === 1) {
            return {
                DossierType: x_2,
            };
        }
        else {
            const s = useFormValidator(asbestInventoryData.Validator, (unitVar_6, x_3) => ({
                AsbestInventoryData: x_3,
                Value: x_3.Value,
            }), useForm()).Validate();
            if (s == null) {
                return {
                    DossierType: x_2,
                };
            }
            else {
                return {
                    DossierType: TypeOfDossierData___UnsafeCreate_Z1D754B91(new TypeOfDossier_1(0, s.Value)),
                };
            }
        }
    }, useForm()))))))))))))))))))))));
    const patternInput_12 = useFeliz_React__React_useState_Static_1505("");
    const comment = patternInput_12[0];
    const patternInput_13 = useFeliz_React__React_useState_Static_1505(true);
    const setDisableDiscountTextInput = patternInput_13[1];
    const patternInput_14 = useFeliz_React__React_useState_Static_1505((matchValue_18 = map((d_45) => d_45.Discount, prefillData), (matchValue_18 == null) ? (new DiscountOption(0)) : ((matchValue_18.tag === 1) ? (new DiscountOption(1)) : ((matchValue_18.tag === 2) ? (new DiscountOption(2)) : (new DiscountOption(0))))));
    const discountOption = patternInput_14[0];
    const isUrgent = useToggle(pVal((d_46) => d_46.IsUrgent, false));
    const floorplan = useFormField(void 0, some);
    const cadastralRecords = useFormField(void 0, some);
    const otherPropertyDocument = useFormField(void 0, some);
    const patternInput_15 = useFeliz_React__React_useState_Static_1505(isPartner ? (new CommentType(1)) : (new CommentType(0)));
    const commentType = patternInput_15[0];
    const patternInput_16 = useFeliz_React__React_useState_Static_1505(false);
    const setExistingAsbestosAttestRequiredError = patternInput_16[1];
    const existingAsbestosAttestRequiredError = patternInput_16[0];
    useReact_useEffect_Z101E1A95(() => {
        if ((hasExistingAsbestosAttest.FieldValue != null) && existingAsbestosAttestRequiredError) {
            setExistingAsbestosAttestRequiredError(false);
        }
    }, [hasExistingAsbestosAttest.FieldValue, existingAsbestosAttestRequiredError]);
    return createElement(Col, {
        classes: singleton_1(Gap.M),
        children: toList(delay(() => append(singleton(createElement(Row, {
            classes: empty(),
            children: singleton_1(createElement(Col, {
                classes: empty(),
                children: singleton_1(createElement(ChooseOwner, {
                    ownerOption: ownerOption,
                    ownerCompanyForm: ownerCompany,
                    ownerPersonForm: ownerPerson,
                })),
            })),
        })), delay(() => append((!isPartner) ? (equals(kind, new DossierKind(0)) ? append(singleton(createElement("h2", {
            children: ["Type"],
        })), delay(() => {
            let elements;
            return singleton(MuiHelpers_createElement(RadioGroup, [["row", false], (elements = [OptionField(dossierTypeData, new TypeOfDossier_1(0, new AsbestInventory(0)), "Asbestinventaris", "", false), OptionField(dossierTypeData, new TypeOfDossier_1(1), "Monstername", "", false)], ["children", Interop_reactApi.Children.toArray(Array.from(elements))])]));
        })) : empty_1()) : empty_1(), delay(() => {
            let elems_2, elements_1;
            return append(singleton(createElement("div", createObj(ofArray([["hidden", true], (elems_2 = [createElement(Row, {
                classes: empty(),
                children: singleton_1(createElement(Col, {
                    classes: empty(),
                    children: ofArray([createElement("h2", {
                        children: ["Opdrachtgever"],
                    }), MuiHelpers_createElement(RadioGroup, [["row", false], (elements_1 = [OptionField(dossierClientData, new DossierClient(0), "Eigenaar", "", false), OptionField(dossierClientData, new DossierClient(1), "Gevolmachtigde", "", false), OptionField(dossierClientData, new DossierClient(2), "Vereniging van mede-eigenaars", "", false)], ["children", Interop_reactApi.Children.toArray(Array.from(elements_1))])])]),
                })),
            })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => append(singleton(createElement(Row, {
                classes: empty(),
                children: singleton_1(createElement(Col, {
                    classes: singleton_1(MarginBottom.L),
                    children: toList(delay(() => {
                        const inspectionLocationGroups = (dossierCreatePageSource.tag === 2) ? ofArray([new InspectionLocationType(0), new InspectionLocationType(1), new InspectionLocationType(2), new InspectionLocationType(3)]) : ofArray([new InspectionLocationType(0), new InspectionLocationType(1)]);
                        return singleton(createElement(ChooseInspectionLocationFormCheckbox, {
                            inspectionLocationData: inspectionLocationData,
                            residentialOther: residentialOther,
                            nonResidentialOther: nonResidentialOther,
                            inSocialUseOther: inSocialUseOther,
                            publicOther: publicOther,
                            selectedLocationGroups: inspectionLocationGroups,
                            hideGroupSelection: isPartner,
                            residentialBerging: residentialBerging,
                            residentialGaragebox: residentialGaragebox,
                        }));
                    })),
                })),
            })), delay(() => append(equals(kind, new DossierKind(1)) ? (equals(inspectionLocationData.FieldValue, new InspectionLocation_1(13)) ? append(singleton(createElement("h3", {
                className: join(" ", [MarginBottom.Xxs]),
                children: "Bouwvorm woonhuis (optioneel)",
            })), delay(() => {
                let elements_2;
                return singleton(MuiHelpers_createElement(RadioGroup, [["row", true], (elements_2 = toList(delay(() => map_1((f) => OptionField(woonhuisBuildingForm, f, WoonhuisBuildingForm__get_label(f), "", false), WoonhuisBuildingForm_get_list()))), ["children", Interop_reactApi.Children.toArray(Array.from(elements_2))])]));
            })) : empty_1()) : empty_1(), delay(() => append(equals(dossierCreatePageSource, new DossierCreatePageSource(2)) ? singleton(createElement(Row, {
                classes: singleton_1(PaddingTop.S),
                children: singleton_1(createElement(Col, {
                    classes: ofArray([MarginBottom.L, Gap.M]),
                    children: ofArray([TextField(additionalGarage, "Aanvullende garage", "", false), TextField(additionalGardenbox, "Aanvullende tuinbox", "", false), TextField(additionalGreenhouse, "Aanvullende serre", "", false)]),
                })),
            })) : empty_1(), delay(() => append(singleton(createElement(Col, {
                classes: singleton_1(Gap.M),
                children: toList(delay(() => append(singleton(createElement("h2", {
                    children: ["Statuut eigenaar"],
                })), delay(() => {
                    let elements_3;
                    return append(singleton(MuiHelpers_createElement(RadioGroup, [["row", false], (elements_3 = toList(delay(() => append(singleton(OptionField(ownerStatusData, new OwnerStatus_2(0), "Particulier", "", false)), delay(() => append(singleton(OptionField(ownerStatusData, new OwnerStatus_2(6), "Onderneming", "", false)), delay(() => append(singleton(OptionField(ownerStatusData, new OwnerStatus_2(7), "VME (vereniging van medeeigneaars)", "", false)), delay(() => append(singleton(OptionField(ownerStatusData, new OwnerStatus_2(1), "Sociale huisvestingsmaatschappij", "", false)), delay(() => {
                        let matchValue_32;
                        return append((dossierCreatePageSource.tag === 0) ? ((matchValue_32 = inspectionLocationData.FieldValue, (matchValue_32 != null) ? ((matchValue_32.tag === 0) ? append(singleton(OptionField(ownerStatusData, new OwnerStatus_2(3), "Overheid/Parastatale (Vlaams gewest)", "", false)), delay(() => append(singleton(OptionField(ownerStatusData, new OwnerStatus_2(4), "Overheid/Parastatale (Lokaal/Regionaal)", "", false)), delay(() => singleton(OptionField(ownerStatusData, new OwnerStatus_2(5), "Overheid/Parastatale (Federaal)", "", false)))))) : ((matchValue_32.tag === 1) ? append(singleton(OptionField(ownerStatusData, new OwnerStatus_2(3), "Overheid/Parastatale (Vlaams gewest)", "", false)), delay(() => append(singleton(OptionField(ownerStatusData, new OwnerStatus_2(4), "Overheid/Parastatale (Lokaal/Regionaal)", "", false)), delay(() => singleton(OptionField(ownerStatusData, new OwnerStatus_2(5), "Overheid/Parastatale (Federaal)", "", false)))))) : ((matchValue_32.tag === 2) ? append(singleton(OptionField(ownerStatusData, new OwnerStatus_2(3), "Overheid/Parastatale (Vlaams gewest)", "", false)), delay(() => append(singleton(OptionField(ownerStatusData, new OwnerStatus_2(4), "Overheid/Parastatale (Lokaal/Regionaal)", "", false)), delay(() => singleton(OptionField(ownerStatusData, new OwnerStatus_2(5), "Overheid/Parastatale (Federaal)", "", false)))))) : ((matchValue_32.tag === 3) ? append(singleton(OptionField(ownerStatusData, new OwnerStatus_2(3), "Overheid/Parastatale (Vlaams gewest)", "", false)), delay(() => append(singleton(OptionField(ownerStatusData, new OwnerStatus_2(4), "Overheid/Parastatale (Lokaal/Regionaal)", "", false)), delay(() => singleton(OptionField(ownerStatusData, new OwnerStatus_2(5), "Overheid/Parastatale (Federaal)", "", false)))))) : singleton(null))))) : singleton(null))) : singleton(null), delay(() => ((dossierCreatePageSource.tag === 0) ? singleton(OptionField(ownerStatusData, new OwnerStatus_2(8), "Andere", "", false)) : singleton(null))));
                    })))))))))), ["children", Interop_reactApi.Children.toArray(Array.from(elements_3))])])), delay(() => {
                        let otherfieldDisabled;
                        const matchValue_34 = ownerStatusData.FieldValue;
                        let pattern_matching_result_4;
                        if (matchValue_34 != null) {
                            if (matchValue_34.tag === 8) {
                                pattern_matching_result_4 = 0;
                            }
                            else {
                                pattern_matching_result_4 = 1;
                            }
                        }
                        else {
                            pattern_matching_result_4 = 1;
                        }
                        switch (pattern_matching_result_4) {
                            case 0: {
                                otherfieldDisabled = false;
                                break;
                            }
                            case 1: {
                                otherfieldDisabled = true;
                                break;
                            }
                        }
                        return (!otherfieldDisabled) ? singleton(createElement(Col, {
                            classes: singleton_1(PaddingLeft.L),
                            children: singleton_1(TextFieldDisabled(ownerStatusOther, "", "", true, otherfieldDisabled)),
                        })) : empty_1();
                    }));
                })))),
            })), delay(() => {
                let matchValue_35, xs_2, elements_4;
                const checkboxField = (label, toggleHook) => MuiHelpers_createElement(FormControlLabel, [["label", label], ["control", MuiHelpers_createElement(Checkbox, [["checked", toggleHook.State], ["onChange", (n) => {
                    toggleHook.Toggle();
                }]])]]);
                return append((matchValue_35 = inspectionLocationData.FieldValue, (matchValue_35 != null) ? ((matchValue_35.tag === 14) ? singleton((xs_2 = [createElement("h2", {
                    children: ["Zijn er een of meerdere van de volgende extra ruimtes aanwezig"],
                }), MuiHelpers_createElement(RadioGroup, [["row", false], (elements_4 = [checkboxField(InspectionLocation_extra(new InspectionLocationExtra(0)), inspectionLocationBerging), checkboxField(InspectionLocation_extra(new InspectionLocationExtra(1)), inspectionLocationStaanplaats), checkboxField(InspectionLocation_extra(new InspectionLocationExtra(2)), inspectionLocationGaragebox)], ["children", Interop_reactApi.Children.toArray(Array.from(elements_4))])])], react.createElement(react.Fragment, {}, ...xs_2))) : ((matchValue_35.tag === 16) ? singleton((xs_2 = [createElement("h2", {
                    children: ["Zijn er een of meerdere van de volgende extra ruimtes aanwezig"],
                }), MuiHelpers_createElement(RadioGroup, [["row", false], (elements_4 = [checkboxField(InspectionLocation_extra(new InspectionLocationExtra(0)), inspectionLocationBerging), checkboxField(InspectionLocation_extra(new InspectionLocationExtra(1)), inspectionLocationStaanplaats), checkboxField(InspectionLocation_extra(new InspectionLocationExtra(2)), inspectionLocationGaragebox)], ["children", Interop_reactApi.Children.toArray(Array.from(elements_4))])])], react.createElement(react.Fragment, {}, ...xs_2))) : ((matchValue_35.tag === 15) ? singleton((xs_2 = [createElement("h2", {
                    children: ["Zijn er een of meerdere van de volgende extra ruimtes aanwezig"],
                }), MuiHelpers_createElement(RadioGroup, [["row", false], (elements_4 = [checkboxField(InspectionLocation_extra(new InspectionLocationExtra(0)), inspectionLocationBerging), checkboxField(InspectionLocation_extra(new InspectionLocationExtra(1)), inspectionLocationStaanplaats), checkboxField(InspectionLocation_extra(new InspectionLocationExtra(2)), inspectionLocationGaragebox)], ["children", Interop_reactApi.Children.toArray(Array.from(elements_4))])])], react.createElement(react.Fragment, {}, ...xs_2))) : singleton(null)))) : singleton(null)), delay(() => {
                    let matchValue_36;
                    return append((matchValue_36 = inspectionLocationData.FieldValue, (matchValue_36 != null) ? ((matchValue_36.tag === 14) ? singleton(TextField(buildingDetail, "Gebouwdeel, vleugel, blok", "", false)) : ((matchValue_36.tag === 16) ? singleton(TextField(buildingDetail, "Gebouwdeel, vleugel, blok", "", false)) : ((matchValue_36.tag === 15) ? singleton(TextField(buildingDetail, "Gebouwdeel, vleugel, blok", "", false)) : ((matchValue_36.tag === 17) ? singleton(TextField(buildingDetail, "Gebouwdeel, vleugel, blok", "", false)) : singleton(null))))) : singleton(null)), delay(() => append(singleton(TextField(yearOfConstruction, "Jaar van constructie", "", false)), delay(() => append(yearOfConstructionRequiredError ? singleton(createElement("div", {
                        className: join(" ", [error]),
                        children: "Vereist.",
                    })) : empty_1(), delay(() => append(equals(dossierCreatePageSource, new DossierCreatePageSource(2)) ? append(singleton(TextField(yearOfRenovation, "Jaar van renovatie", "", false)), delay(() => append(yearOfConstructionRequiredError ? singleton(createElement("div", {
                        className: join(" ", [error]),
                        children: "Vereist.",
                    })) : empty_1(), delay(() => append(singleton(TextField(numberOfEntrances, "Aantal ingangen in het gebouw", "", false)), delay(() => append(singleton(TextField(pipleIsolationMeters, "Leidingisolatie (lopende meter)", "", false)), delay(() => singleton(TextField(hallwaysPerLevel, "Gangen per verdiep", "", false)))))))))) : empty_1(), delay(() => {
                        let matchValue_37;
                        return append((matchValue_37 = inspectionLocationData.FieldValue, (matchValue_37 != null) ? ((matchValue_37.tag === 22) ? append(singleton(TextField(sharedAreaOption1, "Tellerlokalen", "", false)), delay(() => append(singleton(TextField(sharedAreaOption2, "Vuilnislokaal", "", false)), delay(() => append(singleton(TextField(sharedAreaOption3, "Fietsberging", "", false)), delay(() => singleton(TextField(sharedAreaOption4, "Gemene Delen Option 4", "", false)))))))) : singleton(null)) : singleton(null)), delay(() => append(equals(dossierCreatePageSource, new DossierCreatePageSource(2)) ? singleton(MuiHelpers_createElement(FormControlLabel, [["label", ["Stooklokaal"]], ["control", MuiHelpers_createElement(Switch, [["checked", boilerRoom.State]])], ["onChange", (e) => {
                            const s_1 = Browser_Types_Event__Event_get_Checked(e);
                            boilerRoom.Toggle();
                        }]])) : empty_1(), delay(() => {
                            let elements_5;
                            return append(singleton(createElement(Row, {
                                classes: empty(),
                                children: singleton_1(createElement(Col, {
                                    classes: singleton_1(MarginRight.Xl),
                                    children: ofArray([createElement("h2", {
                                        children: ["Eigenaar gebruiker van het inspectiegebied"],
                                    }), MuiHelpers_createElement(RadioGroup, [["row", false], (elements_5 = [OptionField(isUserOwnerOfArea, true, "Ja: bv. u woont of werk er", "", false), OptionField(isUserOwnerOfArea, false, "Nee: bv. u verhuurt de eigendom", "", false)], ["children", Interop_reactApi.Children.toArray(Array.from(elements_5))])])]),
                                })),
                            })), delay(() => {
                                let matchValue_38;
                                const inspectionLocationAddressLabel = (dossierCreatePageSource.tag === 2) ? "Zelfde als eigenaar" : ((dossierCreatePageSource.tag === 0) ? "Zelfde als klant" : "Zelfde als eigenaar");
                                const sameAsCustomerAddress = ((matchValue_38 = ownerOption.FieldValue, (matchValue_38 == null) ? false : ((matchValue_38.tag === 0) ? ((((!isNullOrEmpty(ownerPerson.AddressField.StreetField.FieldValue)) && (!isNullOrEmpty(ownerPerson.AddressField.City.FieldValue))) && (!isNullOrEmpty(ownerPerson.AddressField.NumberField.FieldValue))) && (!isNullOrEmpty(ownerPerson.AddressField.PostalCodeField.FieldValue))) : ((((!isNullOrEmpty(ownerCompany.AddressField.StreetField.FieldValue)) && (!isNullOrEmpty(ownerCompany.AddressField.City.FieldValue))) && (!isNullOrEmpty(ownerCompany.AddressField.NumberField.FieldValue))) && (!isNullOrEmpty(ownerCompany.AddressField.PostalCodeField.FieldValue)))))) ? MuiHelpers_createElement(FormControlLabel, [["label", inspectionLocationAddressLabel], ["control", MuiHelpers_createElement(Checkbox, [["checked", isSameAddress]])], ["onChange", (e_1) => {
                                    const s_2 = Browser_Types_Event__Event_get_Checked(e_1);
                                    patternInput_7[1](s_2);
                                    if (s_2) {
                                        const matchValue_39 = ownerOption.FieldValue;
                                        if (matchValue_39 == null) {
                                        }
                                        else if (matchValue_39.tag === 0) {
                                            addressCase.StreetField.SetFieldValue(ownerPerson.AddressField.StreetField.FieldValue);
                                            addressCase.BusField.SetFieldValue(ownerPerson.AddressField.BusField.FieldValue);
                                            addressCase.City.SetFieldValue(ownerPerson.AddressField.City.FieldValue);
                                            addressCase.NumberField.SetFieldValue(ownerPerson.AddressField.NumberField.FieldValue);
                                            addressCase.PostalCodeField.SetFieldValue(ownerPerson.AddressField.PostalCodeField.FieldValue);
                                        }
                                        else {
                                            addressCase.StreetField.SetFieldValue(ownerCompany.AddressField.StreetField.FieldValue);
                                            addressCase.BusField.SetFieldValue(ownerCompany.AddressField.BusField.FieldValue);
                                            addressCase.City.SetFieldValue(ownerCompany.AddressField.City.FieldValue);
                                            addressCase.NumberField.SetFieldValue(ownerCompany.AddressField.NumberField.FieldValue);
                                            addressCase.PostalCodeField.SetFieldValue(ownerCompany.AddressField.PostalCodeField.FieldValue);
                                        }
                                    }
                                    else {
                                        addressCase.StreetField.SetFieldValue("");
                                        addressCase.BusField.SetFieldValue("");
                                        addressCase.City.SetFieldValue("");
                                        addressCase.NumberField.SetFieldValue("");
                                        addressCase.PostalCodeField.SetFieldValue("");
                                    }
                                }]]) : null;
                                return append(singleton(createElement(CreateAddressFormWithReset, {
                                    addressForm: addressCase,
                                    resetOption: sameAsCustomerAddress,
                                    heading: "Adres Inspectielocatie",
                                    isSameAddress: isSameAddress,
                                })), delay(() => append(equals(kind, new DossierKind(0)) ? singleton(createElement(Col, {
                                    classes: singleton_1(Gap.S),
                                    children: toList(delay(() => append(singleton(createElement("h2", {
                                        className: join(" ", toList(delay(() => append(singleton(MarginBottom.Xs), delay(() => (existingAsbestosAttestRequiredError ? singleton(error) : empty_1())))))),
                                        children: "Bestaand asbestattest",
                                    })), delay(() => append(singleton(createElement("div", {
                                        className: join(" ", toList(delay(() => (existingAsbestosAttestRequiredError ? singleton(error) : empty_1())))),
                                        children: "Is dit een actualisatie voor een bestaand asbestattest van hetzelfde inspectiegebied?",
                                    })), delay(() => {
                                        let elements_6;
                                        return append(singleton(MuiHelpers_createElement(RadioGroup, [["row", true], (elements_6 = [OptionField(hasExistingAsbestosAttest, true, "Ja", "", false), OptionField(hasExistingAsbestosAttest, false, "Neen", "", false)], ["children", Interop_reactApi.Children.toArray(Array.from(elements_6))])])), delay(() => append(existingAsbestosAttestRequiredError ? singleton(createElement("div", {
                                            className: error,
                                            children: "Selecteer Ja of Neen.",
                                        })) : empty_1(), delay(() => {
                                            let elements_7, toggleHook_1, elems_9;
                                            return equals(hasExistingAsbestosAttest.FieldValue, true) ? singleton(createElement(Col, {
                                                classes: singleton_1(Gap.Xs),
                                                children: ofArray([createElement("h2", {
                                                    className: MarginBottom.Xs,
                                                    children: "Bestaande asbestattest(en)",
                                                }), TextField(existingAsbestosAttestNumbers, "Nummer(s) bestaand(e) asbestattest(en)", "", false), createElement("h2", {
                                                    className: MarginBottom.Xs,
                                                    children: "Actualisatie",
                                                }), createElement("div", {
                                                    children: "Kruis aan wat van toepassing is en vul aan.",
                                                }), createElement(Col, {
                                                    classes: singleton_1(Gap.Xs),
                                                    children: ofArray([MuiHelpers_createElement(RadioGroup, [["row", false], ["style", {
                                                        rowGap: 0.5 + "rem",
                                                    }], (elements_7 = [checkboxField("Splitsing van bestaand asbestattest", asbestosAttestSplit), checkboxField("Geldigheidstermijn van het asbestattest is verstreken", asbestosAttestExpired), (toggleHook_1 = asbestosAttestMaterialChanged, MuiHelpers_createElement(FormControlLabel, [["style", {
                                                        maxWidth: 42 + "rem",
                                                    }], ["label", "Verwijdering van een asbestmateriaal, aantreffen van (mogelijke) nieuwe asbestmaterialen, zichtbare wijziging van de toestand van een asbestmateriaal door een calamiteit of incident (bv. brand, stormschade, ...)"], ["control", MuiHelpers_createElement(Checkbox, [["checked", toggleHook_1.State], ["onChange", (n_1) => {
                                                        toggleHook_1.Toggle();
                                                    }]])]])), checkboxField("Opheffing van een onderzoeksbeperking", asbestosAttestRestrictionLifted), checkboxField("Andere", asbestosAttestOther)], ["children", Interop_reactApi.Children.toArray(Array.from(elements_7))])]), createElement("div", createObj(ofArray([["className", MarginTop.Xs], ["style", {
                                                        width: 100 + "%",
                                                    }], (elems_9 = [MuiHelpers_createElement(TextField_1, [["value", asbestosAttestOtherDescription.FieldValue], ["onChange", (e_2) => {
                                                        asbestosAttestOtherDescription.SetFieldValue(Browser_Types_Event__Event_get_Value(e_2));
                                                    }], ["disabled", !asbestosAttestOther.State], ["variant", "standard"], ["label", "Beschrijf"], ["error", asbestosAttestOtherDescription.Error], ["helperText", asbestosAttestOtherDescription.Error ? "" : ""], ["required", true], ["fullWidth", true]])], ["children", Interop_reactApi.Children.toArray(Array.from(elems_9))])])))]),
                                                })]),
                                            })) : empty_1();
                                        }))));
                                    })))))),
                                })) : empty_1(), delay(() => append(isPartner ? append(singleton(createElement("h2", {
                                    children: ["Eigendom"],
                                })), delay(() => append(singleton(FileField(cadastralRecords, "Upload Kadastrale legger", "", false)), delay(() => append(singleton(FileField(floorplan, "Upload Grondplan", "", false)), delay(() => singleton(FileField(otherPropertyDocument, "Upload Andere", "", false)))))))) : empty_1(), delay(() => append(singleton(createElement(Col, {
                                    classes: empty(),
                                    children: toList(delay(() => {
                                        let matchValue_40, partners_1;
                                        return append((matchValue_40 = partners, (matchValue_40 == null) ? singleton(null) : ((partners_1 = matchValue_40, append(singleton(createElement("h2", {
                                            children: ["Partner"],
                                        })), delay(() => {
                                            let elems_10;
                                            const options = toArray(delay(() => append(singleton(PartnerOption_get_empty()), delay(() => append(singleton(PartnerOption_get_none()), delay(() => toArray_1(map_2((partner_1) => (new PartnerOption(NonEmptyString___UnsafeUnwrap_Z73AD07C(partner_1.CompanyName), partner_1.Id.Value, partner_1.IsCibPartner, partner_1.PartnerType, partner_1.CompensationAmount, partner_1.CompensationAmountEpc)), partners_1))))))));
                                            return append(singleton(MuiHelpers_createElement(FormControl, [["error", selectPartnerError], (elems_10 = [MuiHelpers_createElement(Autocomplete, [["id", "partner-combo-box-label"], ["options", Array.from(options)], ["value", partnerOption], ["getOptionSelected", (delegateArg, delegateArg_1) => (delegateArg.Id === delegateArg_1.Id)], ["onChange", (_arg_3, v_24, _arg_1_1) => {
                                                const partner_2 = v_24;
                                                if (!(partner_2 == null)) {
                                                    setPartnerOption(partner_2);
                                                    patternInput_3[1](partner_2.IsCibPartner);
                                                    if (partner_2.Id !== PartnerOption_get_empty().Id) {
                                                        setSelectPartnerError(false);
                                                    }
                                                    if ((partner_2.Id === PartnerOption_get_empty().Id) ? true : (partner_2.Id === PartnerOption_get_none().Id)) {
                                                        manualInvoice.On();
                                                    }
                                                    else {
                                                        manualInvoice.Off();
                                                    }
                                                }
                                            }], ["renderInput", (params$0027) => MuiHelpers_createElement(TextField_1, toList(delay(() => append(singleton(["variant", "outlined"]), delay(() => append(singleton(["label", "Partner"]), delay(() => (Object.entries(params$0027)))))))))], ["renderOption", (delegateArg_2, delegateArg_1_1) => {
                                                const partnerOption_1 = delegateArg_2;
                                                const xs_12 = toList(delay(() => {
                                                    let children_3, children_1;
                                                    return (partnerOption_1.PartnerType.tag === 1) ? singleton((children_3 = ofArray([MuiHelpers_createElement(Chip, [["label", "Syndic"], ["className", MarginRight.Xs]]), createElement("span", {
                                                        children: [partnerOption_1.Label],
                                                    })]), createElement("div", {
                                                        children: Interop_reactApi.Children.toArray(Array.from(children_3)),
                                                    }))) : (partnerOption_1.IsCibPartner ? singleton((children_1 = ofArray([MuiHelpers_createElement(Chip, [["label", "CIB"], ["className", MarginRight.Xs]]), createElement("span", {
                                                        children: [partnerOption_1.Label],
                                                    })]), createElement("div", {
                                                        children: Interop_reactApi.Children.toArray(Array.from(children_1)),
                                                    }))) : singleton(createElement("span", {
                                                        children: [partnerOption_1.Label],
                                                    })));
                                                }));
                                                return react.createElement(react.Fragment, {}, ...xs_12);
                                            }], ["filterOptions", (opts_1, s_3) => Array.from(filterPartnerOptions(opts_1, s_3.inputValue))], ["getOptionLabel", (partner_3) => partner_3.Label]])], ["children", Interop_reactApi.Children.toArray(Array.from(elems_10))])])), delay(() => (selectPartnerError ? singleton(createElement(Row, {
                                                classes: ofArray([MarginTop.M, error]),
                                                children: singleton_1("Selecteer een partner of geen"),
                                            })) : empty_1())));
                                        }))))), delay(() => ((equals(dossierCreatePageSource, new DossierCreatePageSource(0)) && (equals(partnerOption, PartnerOption_get_empty()) ? true : equals(partnerOption, PartnerOption_get_none()))) ? singleton(null) : (equals(dossierCreatePageSource, new DossierCreatePageSource(1)) ? singleton(createElement(Col, {
                                            classes: empty(),
                                            children: ofArray([createElement("h2", {
                                                children: ["Vergoedingen"],
                                            }), createElement(CompensationOptionsRestricted, compensationData)]),
                                        })) : singleton(createElement(CompensationOptions, {
                                            compensationData: compensationData,
                                            compensationCustom: compensationCustom_1,
                                            showHeader: true,
                                        }))))));
                                    })),
                                })), delay(() => append((!isPartner) ? append(singleton(createElement(Row, {
                                    classes: ofArray([Gap.M, MarginTop.S]),
                                    children: toList(delay(() => {
                                        let elems_11;
                                        const buttonDisabled = partnerOption.Id === -1;
                                        return singleton(MuiHelpers_createElement(FormControlLabel, [["label", [createElement("div", createObj(singleton_1((elems_11 = [createElement(Row, {
                                            classes: empty(),
                                            children: ofArray([createElement(Col, {
                                                classes: empty(),
                                                children: singleton_1("Automatisch mail verzenden naar "),
                                            }), createElement(Col, {
                                                classes: ofArray([Boldness.b700, MarginLeft.Xs, MarginRight.Xs]),
                                                children: singleton_1("partner"),
                                            }), createElement(Col, {
                                                classes: empty(),
                                                children: singleton_1("(opening dossier en vraag om digitaal het opdrachtformulier te ondertekenen)"),
                                            })]),
                                        })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_11))]))))]], ["disabled", buttonDisabled], ["control", MuiHelpers_createElement(Switch, [["checked", (partnerOption.Id > 0) && sendMailToPartner.State]])], ["onChange", (e_3) => {
                                            const s_4 = Browser_Types_Event__Event_get_Checked(e_3);
                                            sendMailToPartner.Toggle();
                                        }]]));
                                    })),
                                })), delay(() => append(singleton(MuiHelpers_createElement(FormControlLabel, [["label", "Geen standaard dossier"], ["control", MuiHelpers_createElement(Checkbox, [["checked", manualInvoice.State], ["onChange", (e_4) => {
                                    const _arg_4 = Browser_Types_Event__Event_get_Checked(e_4);
                                    manualInvoice.Toggle();
                                }]])]])), delay(() => {
                                    let elements_10;
                                    return singleton(MuiHelpers_createElement(Grid, [["spacing", 2], ["container", true], (elements_10 = toList(delay(() => {
                                        let elements_8, elems_12;
                                        return append(singleton(MuiHelpers_createElement(Grid, [["item", true], ["xs", 2], (elements_8 = [MuiHelpers_createElement(FormControl, [["fullWidth", true], (elems_12 = toList(delay(() => {
                                            const discountOptions = [new DiscountOption(0), new DiscountOption(2), new DiscountOption(1)];
                                            return singleton(MuiHelpers_createElement(Autocomplete, [["id", "discount-combo-box-label"], ["options", Array.from(discountOptions)], ["value", discountOption], ["getOptionSelected", equals], ["onChange", (_arg_5, v_25, _arg_1_2) => {
                                                SafeNotNullCheck(v_25, (discOption) => {
                                                    patternInput_14[1](discOption);
                                                    switch (discOption.tag) {
                                                        case 1:
                                                        case 2: {
                                                            manualInvoice.On();
                                                            setDisableDiscountTextInput(false);
                                                            break;
                                                        }
                                                        default: {
                                                            setDisableDiscountTextInput(true);
                                                        }
                                                    }
                                                });
                                            }], ["renderInput", (params$0027_1) => MuiHelpers_createElement(TextField_1, toList(delay(() => append(singleton(["variant", "outlined"]), delay(() => append(singleton(["label", "Soort korting"]), delay(() => (Object.entries(params$0027_1)))))))))], ["getOptionLabel", DiscountOption__get_Label]]));
                                        })), ["children", Interop_reactApi.Children.toArray(Array.from(elems_12))])])], ["children", Interop_reactApi.Children.toArray(Array.from(elements_8))])])), delay(() => {
                                            let elements_9;
                                            return singleton(MuiHelpers_createElement(Grid, [["item", true], ["xs", 4], (elements_9 = [NumberFieldFloat(discount, "Korting", "", false, patternInput_13[0], (discountOption.tag === 1) ? "€" : ((discountOption.tag === 2) ? "%" : ""))], ["children", Interop_reactApi.Children.toArray(Array.from(elements_9))])]));
                                        }));
                                    })), ["children", Interop_reactApi.Children.toArray(Array.from(elements_10))])]));
                                })))) : empty_1(), delay(() => append((!isPartner) ? singleton(MuiHelpers_createElement(FormControlLabel, [["label", "Factuur aanmaken"], ["control", MuiHelpers_createElement(Checkbox, [["checked", allowInvoice.State], ["onChange", (e_5) => {
                                    const _arg_6 = Browser_Types_Event__Event_get_Checked(e_5);
                                    allowInvoice.Toggle();
                                }]])]])) : empty_1(), delay(() => {
                                    const showPartnerComments = !(equals(partnerOption, PartnerOption_get_empty()) ? true : equals(partnerOption, PartnerOption_get_none()));
                                    return append(singleton(createElement(CommentTypeTabs, {
                                        commentType: commentType,
                                        setCommentType: patternInput_15[1],
                                        content: createElement(CommentEditor, {
                                            comment: comment,
                                            setComment: patternInput_12[1],
                                            commentType: commentType,
                                        }),
                                        showInternal: !isPartner,
                                        showAdi: equals(dossierCreatePageSource, new DossierCreatePageSource(0)),
                                        showPartner: showPartnerComments,
                                    })), delay(() => append(equals(dossierCreatePageSource, new DossierCreatePageSource(1)) ? singleton(MuiHelpers_createElement(FormControlLabel, [["className", error], ["label", "Dringend"], ["control", MuiHelpers_createElement(Checkbox, [["checked", isUrgent.State], ["onChange", (n_2) => {
                                        isUrgent.Toggle();
                                    }]])]])) : empty_1(), delay(() => singleton(createElement(Row, {
                                        classes: ofArray([Gap.M, MarginTop.L]),
                                        children: toList(delay(() => {
                                            let matchValue_42, url;
                                            return append((matchValue_42 = backUrl, (matchValue_42 == null) ? singleton(null) : ((url = matchValue_42, singleton(MuiHelpers_createElement(Button, [["disabled", disable], ["color", "default"], ["variant", "contained"], ["onClick", (_arg_7) => {
                                                RouterModule_nav(ofArray(url), 1, 1);
                                            }], ["children", Interop_reactApi.Children.toArray(["Annuleren"])]]))))), delay(() => {
                                                let elems_18;
                                                return singleton(createElement("div", createObj(ofArray([["hidden", true], (elems_18 = [MuiHelpers_createElement(Button, [["id", "dossier-create-button"], ["ref", buttonRef], ["disabled", disable], ["color", "primary"], ["variant", "contained"], ["onClick", (_arg_2) => {
                                                    const isExistingAsbestosAttestValid = equals(kind, new DossierKind(1)) ? true : (hasExistingAsbestosAttest.FieldValue != null);
                                                    setExistingAsbestosAttestRequiredError(!isExistingAsbestosAttestValid);
                                                    if (((partnerOption.Id === PartnerOption_get_empty().Id) ? ((setSelectPartnerError(true), false)) : true) && isExistingAsbestosAttestValid) {
                                                        iterate((data) => {
                                                            let matchValue_20, matchValue_21;
                                                            if (((data.OwnerStatus.Value.tag === 8) ? (data.OwnerStatusOther != null) : true) && ((matchValue_20 = data.InspectionLocation.Value, (matchValue_20.tag === 3) ? ((matchValue_21 = data.InspectionLocationOther, (matchValue_21 == null) ? false : (!isNullOrWhiteSpace(matchValue_21.Value)))) : ((matchValue_20.tag === 30) ? ((matchValue_21 = data.InspectionLocationOther, (matchValue_21 == null) ? false : (!isNullOrWhiteSpace(matchValue_21.Value)))) : ((matchValue_20.tag === 12) ? ((matchValue_21 = data.InspectionLocationOther, (matchValue_21 == null) ? false : (!isNullOrWhiteSpace(matchValue_21.Value)))) : ((matchValue_20.tag === 23) ? ((matchValue_21 = data.InspectionLocationOther, (matchValue_21 == null) ? false : (!isNullOrWhiteSpace(matchValue_21.Value)))) : true)))))) {
                                                                iterate((owner) => {
                                                                    let matchValue_23, matchValue_24, matchValue_25, matchValue_26, matchValue_27, matchValue_28, matchValue_29, matchValue_30;
                                                                    const inspectionLocationAddress = (dossierCreatePageSource.tag === 0) ? data.Address : ((dossierCreatePageSource.tag === 2) ? (isSameAddress ? DossierOwner__get_Address(owner) : data.Address) : data.Address);
                                                                    setDisable(true);
                                                                    let dossier;
                                                                    const EmailConfirmations = pVal((d_47) => d_47.EmailConfirmations, false);
                                                                    const PartnerId = (partnerOption.Id === 0) ? (void 0) : (new PartnerId_1(partnerOption.Id));
                                                                    dossier = (new CreateDossierData(data.DossierType, data.InspectionLocation, data.InspectionLocationOther, data.ResidentialBerging, data.ResidentialGarageBox, data.DossierClient, data.BuildingDetail, void 0, data.YearsOfConstruction, data.YearOfRenovation, pBind((d_48) => d_48.AwareOfAsbestosDescription), data.IsUserOwnerOfArea.Value, inspectionLocationAddress, EmailConfirmations, new DossierStatus(0), PartnerId, pBind((d_49) => d_49.LegalRepresentativeId), owner, manualInvoice.State, false, pBind((d_50) => d_50.HiddenAsbestos), pBind((d_51) => d_51.FloorPlanAvailable), data.OwnerStatus, data.OwnerStatusOther, (discountOption.tag === 1) ? (new TypeOfDiscount(1, data.Discount)) : ((discountOption.tag === 2) ? (new TypeOfDiscount(2, data.Discount)) : (new TypeOfDiscount(0))), patternInput_3[0], data.InspectionLocationBerging, data.InspectionLocationStaanplaats, data.InspectionLocationGaragebox, isUrgent.State, data.Compensation, pVal((d_52) => d_52.IsRealSmartDossier, false), pBind((d_53) => d_53.QuoteApprovalMeetingDate), data.NumberOfEntrances, data.HallwaysPerLevel, data.PipeIsolationMeters, boilerRoom.State, data.SharedAreaOption1, data.SharedAreaOption2, data.SharedAreaOption3, data.SharedAreaOption4, data.AdditionalGarage, data.AdditionalGardenbox, data.AdditionalGreenhouse, hasExistingAsbestosAttest.FieldValue, (matchValue_23 = hasExistingAsbestosAttest.FieldValue, (matchValue_23 != null) ? (matchValue_23 ? optionalNonEmptyString(existingAsbestosAttestNumbers.FieldValue) : (void 0)) : (void 0)), (matchValue_24 = hasExistingAsbestosAttest.FieldValue, (matchValue_24 != null) ? (matchValue_24 ? asbestosAttestSplit.State : (void 0)) : (void 0)), (matchValue_25 = hasExistingAsbestosAttest.FieldValue, (matchValue_25 != null) ? (matchValue_25 ? asbestosAttestExpired.State : (void 0)) : (void 0)), (matchValue_26 = hasExistingAsbestosAttest.FieldValue, (matchValue_26 != null) ? (matchValue_26 ? asbestosAttestMaterialChanged.State : (void 0)) : (void 0)), (matchValue_27 = hasExistingAsbestosAttest.FieldValue, (matchValue_27 != null) ? (matchValue_27 ? asbestosAttestRestrictionLifted.State : (void 0)) : (void 0)), (matchValue_28 = hasExistingAsbestosAttest.FieldValue, (matchValue_28 != null) ? (matchValue_28 ? asbestosAttestOther.State : (void 0)) : (void 0)), (matchValue_29 = [hasExistingAsbestosAttest.FieldValue, asbestosAttestOther.State], (matchValue_29[0] != null) ? (matchValue_29[0] ? (matchValue_29[1] ? optionalNonEmptyString(asbestosAttestOtherDescription.FieldValue) : (void 0)) : (void 0)) : (void 0)), (matchValue_30 = data.DossierType.Value, (matchValue_30.tag === 0) ? ((matchValue_30.fields[0].tag === 12) ? optionalNonEmptyString(asbestInventoryOtherDescription.FieldValue) : (void 0)) : (void 0)), allowInvoice.State, kind, void 0, woonhuisBuildingForm.FieldValue, assignedAdiId.FieldValue, bind((d_54) => d_54.LinkedDossierId, prefillData)));
                                                                    const comment_1 = (comment.length > 0) ? (new CommentData(comment, "", new CommentSource_1(1), commentType)) : (void 0);
                                                                    toConsole(printf("dossier %A"))(dossier);
                                                                    onCreateDossier(dossier)(comment_1)(floorplan.FieldValue)(cadastralRecords.FieldValue)(otherPropertyDocument.FieldValue)(sendMailToPartner.State)(() => {
                                                                        setDisable(false);
                                                                    });
                                                                }, toArray_2(data.DossierOwner));
                                                            }
                                                        }, toArray_2(form.Validate()));
                                                    }
                                                }], ["children", Interop_reactApi.Children.toArray(["Bewaren"])]])], ["children", Interop_reactApi.Children.toArray(Array.from(elems_18))])]))));
                                            }));
                                        })),
                                    }))))));
                                }))))))))))));
                            }));
                        }))));
                    }))))))));
                }));
            }))))))))));
        })))))),
    });
}

export function CreateDossierStepperPage(createDossierStepperPageInputProps) {
    let matchValue, children_2;
    const prefill = createDossierStepperPageInputProps.prefill;
    const kind = createDossierStepperPageInputProps.kind;
    const compensation = createDossierStepperPageInputProps.compensation;
    const dossierCreatePageSource = createDossierStepperPageInputProps.dossierCreatePageSource;
    const setPartnerId = createDossierStepperPageInputProps.setPartnerId;
    const partnersList = createDossierStepperPageInputProps.partnersList;
    const setCustomer = createDossierStepperPageInputProps.setCustomer;
    const customer = createDossierStepperPageInputProps.customer;
    const onCreateCustomer = createDossierStepperPageInputProps.onCreateCustomer;
    const onCreateDossier = createDossierStepperPageInputProps.onCreateDossier;
    const customers = createDossierStepperPageInputProps.customers;
    const getCustomer = createDossierStepperPageInputProps.getCustomer;
    const customerUrl = createDossierStepperPageInputProps.customerUrl;
    const snackbar = useSnackbar();
    const patternInput = useFeliz_React__React_useState_Static_1505(0);
    const setActiveStep = patternInput[1];
    const activeStep = patternInput[0] | 0;
    const patternInput_1 = useFeliz_React__React_useState_Static_1505([false, false, false]);
    const stepsCompleted = patternInput_1[0];
    const setStepsCompleted = patternInput_1[1];
    const patternInput_2 = useFeliz_React__React_useState_Static_1505(void 0);
    const dossierData = patternInput_2[0];
    const patternInput_3 = useFeliz_React__React_useState_Static_1505(void 0);
    const dossierDataContact = patternInput_3[0];
    const patternInput_4 = useFeliz_React__React_useState_Static_1505(void 0);
    const patternInput_5 = useFeliz_React__React_useState_Static_1505(CustomerOption_get_none());
    const setCustomerOption = patternInput_5[1];
    const patternInput_6 = useFeliz_React__React_useState_Static_1505(false);
    const setShowCustomerForm = patternInput_6[1];
    const dossierCreateButtonRef = useReact_useButtonRef();
    const username = useUsername();
    const patternInput_7 = useFeliz_React__React_useState_Static_1505(false);
    const setCreatingDossier = patternInput_7[1];
    const creatingDossier = patternInput_7[0];
    const topRef = useReact_useElementRef();
    const prefillContact = map((tupledArg) => tupledArg[0].CreateDossierDataContact, prefill);
    const pcBind = (selector) => bind(selector, prefillContact);
    const pcVal = (selector_1, defaultV) => defaultArg(map(selector_1, prefillContact), defaultV);
    const contact = useFormField(map((c) => c.HomeVisitContact, prefillContact), SelectOptionData$1_Create_Z510A3DC0);
    const contactEmail = useFormField(defaultArg(map(PhoneNumber___UnsafeUnwrap_23E45174, pcBind((c_1) => c_1.HomeVisitContactEmail)), ""), PhoneNumber_get_Create());
    const contactName = useFormField(defaultArg(map(NonEmptyString___UnsafeUnwrap_Z73AD07C, pcBind((c_2) => c_2.HomeVisitContactName)), ""), NonEmptyString_get_Create());
    const invoice = useFormField(void 0, SelectOptionData$1_Create_Z510A3DC0);
    const invoiceCustomerPerson = useCreateCustomerPersonForm("", "", "", "", "", "", "", "", "");
    const invoiceCustomerCompany = useCreateCustomerCompanyForm("", "", "", "", "", "", "", "", "", "", false, false, "", "");
    const invoicingPartySameAsOwner = useToggle(false);
    const invoicePricing = useToggle((matchValue = map((c_3) => c_3.InvoicePricing, prefillContact), (matchValue != null) && (matchValue.tag === 0)));
    const assignmentDocumentContact = useFormField(defaultArg(map((c_4) => c_4.AssignmentDocumentContact, prefillContact), new AssignmentDocument(0)), SelectOptionData$1_Create_Z510A3DC0);
    const assignmentDocumentOther = useFormField("", NonEmptyString_get_Create());
    const assignmentDocumentLegalRepEmail = useFormField("", NonEmptyString_get_Create());
    const assignmentDocumentSyndicEmail = useFormField("", NonEmptyString_get_Create());
    const isPartnerSelected = useToggle(true);
    const patternInput_8 = useFeliz_React__React_useState_Static_1505(username);
    const setPartnerName = patternInput_8[1];
    const partnerName = patternInput_8[0];
    const partnerToggle = useToggle(pcVal((c_5) => c_5.CertificateEmailPartner, isPartnerSelected.State));
    const customerToggle = useToggle(pcVal((c_6) => c_6.CertificateEmailClient, true));
    const emailToggle = useToggle(pcVal((c_7) => c_7.CertificateEmailCustom, false));
    const emails = useFormField("", NonEmptyString_get_Create());
    const emailsError = useToggle(false);
    const patternInput_9 = useFeliz_React__React_useState_Static_1505(prefill != null);
    const foundCustomer = patternInput_9[0];
    const patternInput_10 = useFeliz_React__React_useState_Static_1505(void 0);
    const patternInput_11 = useFeliz_React__React_useState_Static_1505(void 0);
    const patternInput_12 = useFeliz_React__React_useState_Static_1505(void 0);
    const patternInput_13 = useFeliz_React__React_useState_Static_1505(false);
    const patternInput_14 = useFeliz_React__React_useState_Static_1505(void 0);
    const patternInput_15 = useFeliz_React__React_useState_Static_1505(void 0);
    const patternInput_16 = useFeliz_React__React_useState_Static_1505(void 0);
    useReact_useEffect_Z101E1A95(() => {
        let customer_1;
        let pattern_matching_result, customer_2;
        if (customer != null) {
            if ((customer_1 = customer, foundCustomer)) {
                pattern_matching_result = 0;
                customer_2 = customer;
            }
            else {
                pattern_matching_result = 1;
            }
        }
        else {
            pattern_matching_result = 1;
        }
        switch (pattern_matching_result) {
            case 0: {
                invoice.SetFieldValue((customer_2.tag === 1) ? (new Invoiced(2)) : (new Invoiced(1)));
                break;
            }
            case 1: {
                break;
            }
        }
    }, [foundCustomer, customer]);
    useReact_useEffect_Z101E1A95(() => {
        const matchValue_1 = [customer, prefill];
        let pattern_matching_result_1, c_9;
        if (matchValue_1[0] != null) {
            if (matchValue_1[1] != null) {
                pattern_matching_result_1 = 0;
                c_9 = matchValue_1[0];
            }
            else {
                pattern_matching_result_1 = 1;
            }
        }
        else {
            pattern_matching_result_1 = 1;
        }
        switch (pattern_matching_result_1) {
            case 0: {
                setCustomerOption(new CustomerOption(Customer2__get_CustomerOrCompanyName(c_9), Customer2__get_Code(c_9).Value));
                break;
            }
            case 1: {
                break;
            }
        }
    }, [customer, prefill]);
    const updateStepCompletion = (idx, value_2, array) => mapIndexed((i, v) => {
        if (i === idx) {
            return value_2;
        }
        else {
            return v;
        }
    }, array);
    useReact_useEffect_Z101E1A95(() => {
        if (item(activeStep, steps).tag === 0) {
            if (dossierData == null) {
            }
            else {
                const dossierData_2 = dossierData;
                switch (dossierCreatePageSource.tag) {
                    case 2: {
                        setPartnerName(username);
                        isPartnerSelected.On();
                        break;
                    }
                    case 0: {
                        const matchValue_13 = dossierData_2.PartnerId;
                        if (matchValue_13 == null) {
                            setPartnerName("Partner");
                            isPartnerSelected.Off();
                        }
                        else {
                            const partnerId = matchValue_13;
                            setPartnerName("Partner" + getPartnerType(partnerId, partnersList));
                            isPartnerSelected.On();
                            patternInput_4[1](partnerId);
                            iterate((n) => {
                                n(partnerId);
                            }, toArray_2(setPartnerId));
                        }
                        break;
                    }
                    default: {
                        setPartnerName(username);
                        isPartnerSelected.On();
                    }
                }
                setStepsCompleted(updateStepCompletion(activeStep, true, stepsCompleted));
                setActiveStep(activeStep + 1);
            }
        }
    }, [dossierData]);
    const createStepLabel = (kind.tag === 1) ? ("EPC " + stepString(new Step(0))) : ("Dossier " + stepString(new Step(0)));
    const xs_7 = [(children_2 = toList(delay(() => append(singleton(createElement("span", {
        ref: topRef,
    })), delay(() => {
        let elements_6, elements_1, elements_3, elements_2, elements_5, elements_4;
        return append(singleton(MuiHelpers_createElement(Stepper, [["activeStep", activeStep], (elements_6 = [MuiHelpers_createElement(Step_1, [["completed", stepsCompleted[0]], (elements_1 = [MuiHelpers_createElement(StepLabel, [["children", Interop_reactApi.Children.toArray([createStepLabel])]])], ["children", Interop_reactApi.Children.toArray(Array.from(elements_1))])]), MuiHelpers_createElement(Step_1, [["completed", stepsCompleted[1]], ["className", join(" ", [Boldness.b700])], (elements_3 = [MuiHelpers_createElement(StepLabel, [(elements_2 = [stepString(new Step(1))], ["children", Interop_reactApi.Children.toArray(Array.from(elements_2))])])], ["children", Interop_reactApi.Children.toArray(Array.from(elements_3))])]), MuiHelpers_createElement(Step_1, [["completed", stepsCompleted[2]], (elements_5 = [MuiHelpers_createElement(StepLabel, [(elements_4 = [stepString(new Step(2))], ["children", Interop_reactApi.Children.toArray(Array.from(elements_4))])])], ["children", Interop_reactApi.Children.toArray(Array.from(elements_5))])])], ["children", Interop_reactApi.Children.toArray(Array.from(elements_6))])])), delay(() => {
            let elems_7;
            return append(singleton(createElement("div", createObj(ofArray([["hidden", activeStep !== 0], (elems_7 = [createElement("h1", {
                children: [createStepLabel],
            }), createElement(CreateDossierForm, {
                customerUrl: (customerId) => customerUrl(customerId.Value),
                backUrl: void 0,
                partners: partnersList,
                onCreateDossier: (dossierData_3) => ((comment_1) => ((floorplan_1) => ((cadastralRecords_1) => ((propertyOther_1) => ((sendEmailToPartner_1) => ((onCompleted) => {
                    patternInput_2[1](dossierData_3);
                    patternInput_10[1](comment_1);
                    patternInput_14[1](floorplan_1);
                    patternInput_15[1](cadastralRecords_1);
                    patternInput_16[1](propertyOther_1);
                    patternInput_13[1](sendEmailToPartner_1);
                    onCompleted();
                })))))),
                isCibDossier: false,
                buttonRef: dossierCreateButtonRef,
                dossierCreatePageSource: dossierCreatePageSource,
                compensation: compensation,
                kind: kind,
                prefill: prefill,
            })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_7))])])))), delay(() => {
                let elems_8;
                return append(singleton(MuiHelpers_createElement(Modal, [["open", patternInput_6[0]], ["onClose", (_arg_3, v_1) => {
                    setShowCustomerForm(false);
                }], ["children", createElement("div", createObj(ofArray([["style", {
                    width: 100 + "%",
                    height: 100 + "%",
                }], ["className", join(" ", [modal, Padding.Xl])], (elems_8 = [createElement(CreateCustomerForm, {
                    onCreateCustomer: onCreateCustomer,
                    saveButtonText: void 0,
                    backButtonText: void 0,
                    isCibCustomer: false,
                    onBack: () => {
                        setShowCustomerForm(false);
                    },
                })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_8))])])))]])), delay(() => {
                    let elems_9;
                    const findCustomer = createElement(DisplayDeferred, {
                        data: customers,
                        view: (customers_1) => {
                            const options = toArray(delay(() => append(singleton(CustomerOption_get_none()), delay(() => toArray_1(map_2((customer_5) => (new CustomerOption(Customer2__get_CustomerOrCompanyName(customer_5), Customer2__get_Code(customer_5).Value)), customers_1.Data))))));
                            return createElement(FindCustomer, {
                                options: options,
                                customerOption: patternInput_5[0],
                                setCustomerOption: setCustomerOption,
                                getCustomer: getCustomer,
                                setShowCustomerForm: setShowCustomerForm,
                                reset: () => {
                                    setCustomer(void 0);
                                },
                                setFoundCustomer: patternInput_9[1],
                            });
                        },
                    });
                    return append(singleton(createElement("div", createObj(ofArray([["hidden", activeStep !== 1], (elems_9 = toList(delay(() => {
                        let value_43;
                        return append(singleton((value_43 = stepString(new Step(1)), createElement("h1", {
                            children: [value_43],
                        }))), delay(() => {
                            let children;
                            const matchValue_15 = dossierData;
                            if (matchValue_15 == null) {
                                return singleton(null);
                            }
                            else {
                                const dossierData_4 = matchValue_15;
                                return singleton((children = ofArray([createElement(ChooseContact, {
                                    contactOption: contact,
                                    partnerName: partnerName,
                                    isPartnerSelected: isPartnerSelected.State,
                                    homeVisitContactName: contactName,
                                    homeVisitContactPhoneNo: contactEmail,
                                }), createElement(ChooseInvoicing, {
                                    invoiceOption: invoice,
                                    partnerName: partnerName,
                                    customerControl: findCustomer,
                                    invoicingPartySameAsOwner: invoicingPartySameAsOwner,
                                    setInvoicedValue: invoice.SetFieldValue,
                                    contactOwner: dossierData_4.DossierOwner,
                                    customerPerson: invoiceCustomerPerson,
                                    customerCompany: invoiceCustomerCompany,
                                    isPartnerInvoicingAvailable: isPartnerSelected.State,
                                    foundCustomer: foundCustomer,
                                    dossierCreatePageSource: dossierCreatePageSource,
                                    invoicePricing: invoicePricing,
                                }), createElement(ChooseCertificateContact, {
                                    partnerToggle: partnerToggle,
                                    customerToggle: customerToggle,
                                    emailToggle: emailToggle,
                                    partnerName: partnerName,
                                    emails: emails,
                                    emailsError: emailsError.State,
                                    isPartnerSelected: isPartnerSelected.State,
                                })]), createElement("div", {
                                    children: Interop_reactApi.Children.toArray(Array.from(children)),
                                })));
                            }
                        }));
                    })), ["children", Interop_reactApi.Children.toArray(Array.from(elems_9))])])))), delay(() => {
                        let elems_10;
                        return append(singleton(createElement("div", createObj(ofArray([["hidden", activeStep !== 2], (elems_10 = toList(delay(() => {
                            let value_47;
                            return append(singleton((value_47 = stepString(new Step(2)), createElement("h1", {
                                children: [value_47],
                            }))), delay(() => {
                                const matchValue_16 = [dossierData, dossierDataContact];
                                let pattern_matching_result_2, dossierData_5, dossierDataContact_2;
                                if (matchValue_16[0] != null) {
                                    if (matchValue_16[1] != null) {
                                        pattern_matching_result_2 = 0;
                                        dossierData_5 = matchValue_16[0];
                                        dossierDataContact_2 = matchValue_16[1];
                                    }
                                    else {
                                        pattern_matching_result_2 = 1;
                                    }
                                }
                                else {
                                    pattern_matching_result_2 = 1;
                                }
                                switch (pattern_matching_result_2) {
                                    case 0: {
                                        return singleton(createElement(Review, {
                                            dossierData: dossierData_5,
                                            dossierDataContact: dossierDataContact_2,
                                            partnerName: partnerName,
                                            isPartnerSelected: isPartnerSelected.State,
                                        }));
                                    }
                                    case 1: {
                                        return singleton(null);
                                    }
                                }
                            }));
                        })), ["children", Interop_reactApi.Children.toArray(Array.from(elems_10))])])))), delay(() => singleton(createElement(Row, {
                            classes: ofArray([Gap.M, MarginTop.L]),
                            children: toList(delay(() => {
                                let elems_11;
                                const hidden = activeStep === 0;
                                return append(singleton(createElement("div", createObj(ofArray([["className", alignEnd], ["hidden", hidden], (elems_11 = [MuiHelpers_createElement(Button, [["color", "default"], ["variant", "contained"], ["disabled", hidden ? true : creatingDossier], ["children", "Terug"], ["onClick", (_arg_5) => {
                                    const matchValue_14 = topRef.current;
                                    if (matchValue_14 == null) {
                                    }
                                    else {
                                        const topRef_2 = matchValue_14;
                                        topRef_2.scrollIntoView(true);
                                    }
                                    setActiveStep(activeStep - 1);
                                }]])], ["children", Interop_reactApi.Children.toArray(Array.from(elems_11))])])))), delay(() => {
                                    let elems_12;
                                    return singleton(createElement("div", createObj(ofArray([["className", alignEnd], (elems_12 = [MuiHelpers_createElement(Button, toList(delay(() => {
                                        let matchValue_17;
                                        return append(singleton(["disabled", (matchValue_17 = item(activeStep, steps), (matchValue_17.tag === 0) ? false : ((matchValue_17.tag === 2) && creatingDossier))]), delay(() => append((activeStep === (length(steps) - 1)) ? singleton(["color", "secondary"]) : singleton(["color", "primary"]), delay(() => append(singleton(["variant", "contained"]), delay(() => append(singleton(["children", (activeStep === (length(steps) - 1)) ? "Bevestigen" : "Volgende stap"]), delay(() => singleton(["onClick", (_arg_6) => {
                                            const matchValue_9 = topRef.current;
                                            if (matchValue_9 == null) {
                                            }
                                            else {
                                                const topRef_1 = matchValue_9;
                                                topRef_1.scrollIntoView(true);
                                            }
                                            const matchValue_10 = item(activeStep, steps);
                                            switch (matchValue_10.tag) {
                                                case 0: {
                                                    iterate((buttonElement) => {
                                                        buttonElement.click();
                                                    }, toArray_2(dossierCreateButtonRef.current));
                                                    break;
                                                }
                                                case 2: {
                                                    const matchValue_11 = [dossierData, dossierDataContact];
                                                    let pattern_matching_result_3, dossierData_1, dossierDataContact_1;
                                                    if (matchValue_11[0] != null) {
                                                        if (matchValue_11[1] != null) {
                                                            pattern_matching_result_3 = 0;
                                                            dossierData_1 = matchValue_11[0];
                                                            dossierDataContact_1 = matchValue_11[1];
                                                        }
                                                        else {
                                                            pattern_matching_result_3 = 1;
                                                        }
                                                    }
                                                    else {
                                                        pattern_matching_result_3 = 1;
                                                    }
                                                    switch (pattern_matching_result_3) {
                                                        case 0: {
                                                            setCreatingDossier(true);
                                                            onCreateDossier(new CreateDossierData2(dossierData_1, dossierDataContact_1))(patternInput_10[0])(patternInput_14[0])(patternInput_15[0])(patternInput_16[0])(patternInput_13[0])(() => {
                                                                setCreatingDossier(false);
                                                            });
                                                            break;
                                                        }
                                                        case 1: {
                                                            break;
                                                        }
                                                    }
                                                    break;
                                                }
                                                default: {
                                                    iterate((data) => {
                                                        let homeVisitContact, matchValue_7, name_1, emails_1, customEmail, e_2, assignmentDocContact;
                                                        if (data.InvoicingParty.tag === 2) {
                                                            ProviderContext__enqueueSnackbar_Z1776A768(snackbar, "Klantrecord niet gevonden voor deze partner. Klik op \u0027Partnerportaal activeren\u0027 op de partnerdetailpagina om er een aan te maken en probeer het vervolgens opnieuw.", SnackbarProp_Variant_Z609E1E86("error"), new EnqueueSnackbarOption(1, false));
                                                        }
                                                        else if ((((homeVisitContact = data.Contact.Value, (emailsError.Off(), (homeVisitContact.tag === 2) ? ((matchValue_7 = [data.ContactName, data.ContactEmail], (matchValue_7[0] != null) && ((name_1 = matchValue_7[0], true)))) : ((homeVisitContact.tag === 3) ? ((matchValue_7 = [data.ContactName, data.ContactEmail], (matchValue_7[0] != null) && ((name_1 = matchValue_7[0], true)))) : true)))) && ((emails_1 = data.CertificateCustomEmails, (customEmail = data.CertificateEmailCustom, (emailsError.Off(), (((!data.CertificateEmailPartner) && (!customEmail)) && (!data.CertificateEmailClient)) ? ((emailsError.On(), false)) : (customEmail ? ((emails_1 == null) ? false : ((e_2 = emails_1, true))) : true)))))) && ((assignmentDocContact = data.AssignmentDocumentContact.Value, (assignmentDocContact.tag === 2) ? (data.AssignmentContactEmail != null) : ((assignmentDocContact.tag === 3) ? (data.AssignmentContactEmail != null) : ((assignmentDocContact.tag === 4) ? (data.AssignmentContactEmail != null) : true))))) {
                                                            patternInput_3[1](new CreateDossierDataContact(data.AssignmentContactEmail, data.AssignmentDocumentContact.Value, data.CertificateCustomEmails, data.CertificateEmailClient, data.CertificateEmailCustom, data.CertificateEmailPartner, data.Contact.Value, data.ContactName, data.ContactEmail, data.InvoicingParty, invoicePricing.State ? (new InvoicePricing(0)) : (new InvoicePricing(1))));
                                                            setStepsCompleted(updateStepCompletion(activeStep, true, stepsCompleted));
                                                            setActiveStep(activeStep + 1);
                                                        }
                                                    }, toArray_2(useFormValidator(assignmentDocumentContact.Validator, (r_3, x_8) => {
                                                        let assignVal;
                                                        const matchValue_6 = x_8.Value;
                                                        switch (matchValue_6.tag) {
                                                            case 2: {
                                                                assignVal = useFormValidator(assignmentDocumentLegalRepEmail.Validator, (unitVar_10, x_9) => ({
                                                                    AssignmentDocumentContactEmail: x_9,
                                                                }), useForm()).Validate();
                                                                break;
                                                            }
                                                            case 3: {
                                                                assignVal = useFormValidator(assignmentDocumentSyndicEmail.Validator, (unitVar_11, x_10) => ({
                                                                    AssignmentDocumentContactEmail: x_10,
                                                                }), useForm()).Validate();
                                                                break;
                                                            }
                                                            case 4: {
                                                                assignVal = useFormValidator(assignmentDocumentOther.Validator, (unitVar_12, x_11) => ({
                                                                    AssignmentDocumentContactEmail: x_11,
                                                                }), useForm()).Validate();
                                                                break;
                                                            }
                                                            default: {
                                                                assignVal = (void 0);
                                                            }
                                                        }
                                                        if (assignVal == null) {
                                                            return {
                                                                AssignmentContactEmail: void 0,
                                                                AssignmentDocumentContact: x_8,
                                                                CertificateCustomEmails: r_3.CertificateCustomEmails,
                                                                CertificateEmailClient: r_3.CertificateEmailClient,
                                                                CertificateEmailCustom: r_3.CertificateEmailCustom,
                                                                CertificateEmailPartner: r_3.CertificateEmailPartner,
                                                                Contact: r_3.Contact,
                                                                ContactEmail: r_3.ContactEmail,
                                                                ContactName: r_3.ContactName,
                                                                InvoicingParty: r_3.InvoicingParty,
                                                            };
                                                        }
                                                        else {
                                                            return {
                                                                AssignmentContactEmail: assignVal.AssignmentDocumentContactEmail,
                                                                AssignmentDocumentContact: x_8,
                                                                CertificateCustomEmails: r_3.CertificateCustomEmails,
                                                                CertificateEmailClient: r_3.CertificateEmailClient,
                                                                CertificateEmailCustom: r_3.CertificateEmailCustom,
                                                                CertificateEmailPartner: r_3.CertificateEmailPartner,
                                                                Contact: r_3.Contact,
                                                                ContactEmail: r_3.ContactEmail,
                                                                ContactName: r_3.ContactName,
                                                                InvoicingParty: r_3.InvoicingParty,
                                                            };
                                                        }
                                                    }, useFormValidator(invoice.Validator, (r_2, x_5) => {
                                                        if (foundCustomer) {
                                                            if (customer == null) {
                                                                return {
                                                                    CertificateCustomEmails: r_2.CertificateCustomEmails,
                                                                    CertificateEmailClient: r_2.CertificateEmailClient,
                                                                    CertificateEmailCustom: r_2.CertificateEmailCustom,
                                                                    CertificateEmailPartner: r_2.CertificateEmailPartner,
                                                                    Contact: r_2.Contact,
                                                                    ContactEmail: r_2.ContactEmail,
                                                                    ContactName: r_2.ContactName,
                                                                    InvoicingParty: new DossierCustomer(2),
                                                                };
                                                            }
                                                            else {
                                                                return {
                                                                    CertificateCustomEmails: r_2.CertificateCustomEmails,
                                                                    CertificateEmailClient: r_2.CertificateEmailClient,
                                                                    CertificateEmailCustom: r_2.CertificateEmailCustom,
                                                                    CertificateEmailPartner: r_2.CertificateEmailPartner,
                                                                    Contact: r_2.Contact,
                                                                    ContactEmail: r_2.ContactEmail,
                                                                    ContactName: r_2.ContactName,
                                                                    InvoicingParty: new DossierCustomer(1, new DossierCustomerSelection(0, customer)),
                                                                };
                                                            }
                                                        }
                                                        else {
                                                            const matchValue_3 = x_5.Value;
                                                            switch (matchValue_3.tag) {
                                                                case 1: {
                                                                    const matchValue_4 = useFormValidator(invoiceCustomerPerson.Validator, (unitVar_8, x_6) => ({
                                                                        CustomerPersonData: x_6,
                                                                    }), useForm()).Validate();
                                                                    if (matchValue_4 == null) {
                                                                        return {
                                                                            CertificateCustomEmails: r_2.CertificateCustomEmails,
                                                                            CertificateEmailClient: r_2.CertificateEmailClient,
                                                                            CertificateEmailCustom: r_2.CertificateEmailCustom,
                                                                            CertificateEmailPartner: r_2.CertificateEmailPartner,
                                                                            Contact: r_2.Contact,
                                                                            ContactEmail: r_2.ContactEmail,
                                                                            ContactName: r_2.ContactName,
                                                                            InvoicingParty: new DossierCustomer(2),
                                                                        };
                                                                    }
                                                                    else {
                                                                        const c_11 = matchValue_4.CustomerPersonData;
                                                                        return {
                                                                            CertificateCustomEmails: r_2.CertificateCustomEmails,
                                                                            CertificateEmailClient: r_2.CertificateEmailClient,
                                                                            CertificateEmailCustom: r_2.CertificateEmailCustom,
                                                                            CertificateEmailPartner: r_2.CertificateEmailPartner,
                                                                            Contact: r_2.Contact,
                                                                            ContactEmail: r_2.ContactEmail,
                                                                            ContactName: r_2.ContactName,
                                                                            InvoicingParty: new DossierCustomer(1, new DossierCustomerSelection(1, new CustomerData2(0, new CustomerPersonData(c_11.LastName, c_11.FirstName, c_11.Address, c_11.Email, c_11.PhoneNumber, false)))),
                                                                        };
                                                                    }
                                                                }
                                                                case 2: {
                                                                    const matchValue_5 = useFormValidator(invoiceCustomerCompany.Validator, (unitVar_9, x_7) => ({
                                                                        CustomerCompanyData: x_7,
                                                                    }), useForm()).Validate();
                                                                    if (matchValue_5 == null) {
                                                                        return {
                                                                            CertificateCustomEmails: r_2.CertificateCustomEmails,
                                                                            CertificateEmailClient: r_2.CertificateEmailClient,
                                                                            CertificateEmailCustom: r_2.CertificateEmailCustom,
                                                                            CertificateEmailPartner: r_2.CertificateEmailPartner,
                                                                            Contact: r_2.Contact,
                                                                            ContactEmail: r_2.ContactEmail,
                                                                            ContactName: r_2.ContactName,
                                                                            InvoicingParty: new DossierCustomer(2),
                                                                        };
                                                                    }
                                                                    else {
                                                                        const c_13 = matchValue_5.CustomerCompanyData;
                                                                        return {
                                                                            CertificateCustomEmails: r_2.CertificateCustomEmails,
                                                                            CertificateEmailClient: r_2.CertificateEmailClient,
                                                                            CertificateEmailCustom: r_2.CertificateEmailCustom,
                                                                            CertificateEmailPartner: r_2.CertificateEmailPartner,
                                                                            Contact: r_2.Contact,
                                                                            ContactEmail: r_2.ContactEmail,
                                                                            ContactName: r_2.ContactName,
                                                                            InvoicingParty: new DossierCustomer(1, new DossierCustomerSelection(1, new CustomerData2(1, new CustomerCompanyData(c_13.CompanyName, c_13.CompanyType, c_13.Address, c_13.Email, c_13.PhoneNumber, c_13.VatNumber, false, c_13.IsVME, c_13.IsSocialHousingCompany, c_13.LastName, c_13.FirstName)))),
                                                                        };
                                                                    }
                                                                }
                                                                default: {
                                                                    if (customer == null) {
                                                                        return {
                                                                            CertificateCustomEmails: r_2.CertificateCustomEmails,
                                                                            CertificateEmailClient: r_2.CertificateEmailClient,
                                                                            CertificateEmailCustom: r_2.CertificateEmailCustom,
                                                                            CertificateEmailPartner: r_2.CertificateEmailPartner,
                                                                            Contact: r_2.Contact,
                                                                            ContactEmail: r_2.ContactEmail,
                                                                            ContactName: r_2.ContactName,
                                                                            InvoicingParty: new DossierCustomer(2),
                                                                        };
                                                                    }
                                                                    else {
                                                                        return {
                                                                            CertificateCustomEmails: r_2.CertificateCustomEmails,
                                                                            CertificateEmailClient: r_2.CertificateEmailClient,
                                                                            CertificateEmailCustom: r_2.CertificateEmailCustom,
                                                                            CertificateEmailPartner: r_2.CertificateEmailPartner,
                                                                            Contact: r_2.Contact,
                                                                            ContactEmail: r_2.ContactEmail,
                                                                            ContactName: r_2.ContactName,
                                                                            InvoicingParty: new DossierCustomer(0, customer),
                                                                        };
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }, useFormValidator(contact.Validator, (r_1, x_3) => {
                                                        const partnerEmail = isPartnerSelected.State && partnerToggle.State;
                                                        if (emailToggle.State) {
                                                            const emailsVal_1 = useFormValidator(emails.Validator, (unitVar_7, x_4) => ({
                                                                CertificateCustomEmails: x_4,
                                                            }), useForm()).Validate();
                                                            if (emailsVal_1 == null) {
                                                                return {
                                                                    CertificateCustomEmails: void 0,
                                                                    CertificateEmailClient: customerToggle.State,
                                                                    CertificateEmailCustom: emailToggle.State,
                                                                    CertificateEmailPartner: partnerEmail,
                                                                    Contact: r_1.Contact,
                                                                    ContactEmail: r_1.ContactEmail,
                                                                    ContactName: r_1.ContactName,
                                                                };
                                                            }
                                                            else {
                                                                return {
                                                                    CertificateCustomEmails: emailsVal_1.CertificateCustomEmails,
                                                                    CertificateEmailClient: customerToggle.State,
                                                                    CertificateEmailCustom: emailToggle.State,
                                                                    CertificateEmailPartner: partnerEmail,
                                                                    Contact: r_1.Contact,
                                                                    ContactEmail: r_1.ContactEmail,
                                                                    ContactName: r_1.ContactName,
                                                                };
                                                            }
                                                        }
                                                        else {
                                                            return {
                                                                CertificateCustomEmails: void 0,
                                                                CertificateEmailClient: customerToggle.State,
                                                                CertificateEmailCustom: emailToggle.State,
                                                                CertificateEmailPartner: partnerEmail,
                                                                Contact: r_1.Contact,
                                                                ContactEmail: r_1.ContactEmail,
                                                                ContactName: r_1.ContactName,
                                                            };
                                                        }
                                                    }, useFormValidator(contact.Validator, (unitVar_5, x) => {
                                                        const matchValue_2 = x.Value;
                                                        switch (matchValue_2.tag) {
                                                            case 2:
                                                            case 3: {
                                                                const emailsVal = useFormValidator(contactEmail.Validator, (r, x_2) => ({
                                                                    ContactEmail: x_2,
                                                                    ContactName: r.ContactName,
                                                                }), useFormValidator(contactName.Validator, (unitVar_6, x_1) => ({
                                                                    ContactName: x_1,
                                                                }), useForm())).Validate();
                                                                if (emailsVal == null) {
                                                                    return {
                                                                        Contact: x,
                                                                        ContactEmail: void 0,
                                                                        ContactName: void 0,
                                                                    };
                                                                }
                                                                else {
                                                                    const e = emailsVal;
                                                                    return {
                                                                        Contact: x,
                                                                        ContactEmail: e.ContactEmail,
                                                                        ContactName: e.ContactName,
                                                                    };
                                                                }
                                                            }
                                                            default: {
                                                                return {
                                                                    Contact: x,
                                                                    ContactEmail: void 0,
                                                                    ContactName: void 0,
                                                                };
                                                            }
                                                        }
                                                    }, useForm())))).Validate()));
                                                }
                                            }
                                        }])))))))));
                                    })))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_12))])]))));
                                }));
                            })),
                        }))));
                    }));
                }));
            }));
        }));
    })))), createElement("div", {
        children: Interop_reactApi.Children.toArray(Array.from(children_2)),
    }))];
    return react.createElement(react.Fragment, {}, ...xs_7);
}

